var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a2, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a2, prop, b2[prop]);
    }
  return a2;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import t, { PureComponent as e } from "react";
var n = { exports: {} };
function r() {
}
function i() {
}
i.resetWarningCache = r;
n.exports = (() => {
  function t12(t13, e3, n3, r2, i2, o2) {
    if (o2 !== "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED") {
      var a2 = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw a2.name = "Invariant Violation", a2;
    }
  }
  function e2() {
    return t12;
  }
  t12.isRequired = t12;
  var n2 = { array: t12, bigint: t12, bool: t12, func: t12, number: t12, object: t12, string: t12, symbol: t12, any: t12, arrayOf: e2, element: t12, elementType: t12, instanceOf: e2, node: t12, objectOf: e2, oneOf: e2, oneOfType: e2, shape: e2, exact: e2, checkPropTypes: i, resetWarningCache: r };
  return n2.PropTypes = n2, n2;
})();
var o = n.exports;
function a(t12, e2) {
  if ((n2 = (t12 = e2 ? t12.toExponential(e2 - 1) : t12.toExponential()).indexOf("e")) < 0)
    return null;
  var n2, r2 = t12.slice(0, n2);
  return [r2.length > 1 ? r2[0] + r2.slice(2) : r2, +t12.slice(n2 + 1)];
}
function u(t12) {
  return (t12 = a(Math.abs(t12))) ? t12[1] : NaN;
}
var s, l = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function c(t12) {
  if (!(e2 = l.exec(t12)))
    throw new Error("invalid format: " + t12);
  var e2;
  return new h({ fill: e2[1], align: e2[2], sign: e2[3], symbol: e2[4], zero: e2[5], width: e2[6], comma: e2[7], precision: e2[8] && e2[8].slice(1), trim: e2[9], type: e2[10] });
}
function h(t12) {
  this.fill = t12.fill === void 0 ? " " : t12.fill + "", this.align = t12.align === void 0 ? ">" : t12.align + "", this.sign = t12.sign === void 0 ? "-" : t12.sign + "", this.symbol = t12.symbol === void 0 ? "" : t12.symbol + "", this.zero = !!t12.zero, this.width = t12.width === void 0 ? void 0 : +t12.width, this.comma = !!t12.comma, this.precision = t12.precision === void 0 ? void 0 : +t12.precision, this.trim = !!t12.trim, this.type = t12.type === void 0 ? "" : t12.type + "";
}
function f(t12, e2) {
  var n2 = a(t12, e2);
  if (!n2)
    return t12 + "";
  var r2 = n2[0], i2 = n2[1];
  return i2 < 0 ? "0." + new Array(-i2).join("0") + r2 : r2.length > i2 + 1 ? r2.slice(0, i2 + 1) + "." + r2.slice(i2 + 1) : r2 + new Array(i2 - r2.length + 2).join("0");
}
c.prototype = h.prototype, h.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
};
var p = { "%": (t12, e2) => (100 * t12).toFixed(e2), b: (t12) => Math.round(t12).toString(2), c: (t12) => t12 + "", d: function(t12) {
  return Math.abs(t12 = Math.round(t12)) >= 1e21 ? t12.toLocaleString("en").replace(/,/g, "") : t12.toString(10);
}, e: (t12, e2) => t12.toExponential(e2), f: (t12, e2) => t12.toFixed(e2), g: (t12, e2) => t12.toPrecision(e2), o: (t12) => Math.round(t12).toString(8), p: (t12, e2) => f(100 * t12, e2), r: f, s: function(t12, e2) {
  var n2 = a(t12, e2);
  if (!n2)
    return t12 + "";
  var r2 = n2[0], i2 = n2[1], o2 = i2 - (s = 3 * Math.max(-8, Math.min(8, Math.floor(i2 / 3)))) + 1, u2 = r2.length;
  return o2 === u2 ? r2 : o2 > u2 ? r2 + new Array(o2 - u2 + 1).join("0") : o2 > 0 ? r2.slice(0, o2) + "." + r2.slice(o2) : "0." + new Array(1 - o2).join("0") + a(t12, Math.max(0, e2 + o2 - 1))[0];
}, X: (t12) => Math.round(t12).toString(16).toUpperCase(), x: (t12) => Math.round(t12).toString(16) };
function d(t12) {
  return t12;
}
var g, y, m, v = Array.prototype.map, _ = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function b(t12) {
  var e2, n2, r2 = t12.grouping === void 0 || t12.thousands === void 0 ? d : (e2 = v.call(t12.grouping, Number), n2 = t12.thousands + "", (t13, r3) => {
    for (var i3 = t13.length, o3 = [], a3 = 0, u2 = e2[0], s2 = 0; i3 > 0 && u2 > 0 && (s2 + u2 + 1 > r3 && (u2 = Math.max(1, r3 - s2)), o3.push(t13.substring(i3 -= u2, i3 + u2)), !((s2 += u2 + 1) > r3)); )
      u2 = e2[a3 = (a3 + 1) % e2.length];
    return o3.reverse().join(n2);
  }), i2 = t12.currency === void 0 ? "" : t12.currency[0] + "", o2 = t12.currency === void 0 ? "" : t12.currency[1] + "", a2 = t12.decimal === void 0 ? "." : t12.decimal + "", l2 = t12.numerals === void 0 ? d : function(t13) {
    return (e3) => e3.replace(/[0-9]/g, (e4) => t13[+e4]);
  }(v.call(t12.numerals, String)), h2 = t12.percent === void 0 ? "%" : t12.percent + "", f2 = t12.minus === void 0 ? "\u2212" : t12.minus + "", g2 = t12.nan === void 0 ? "NaN" : t12.nan + "";
  function y2(t13) {
    var e3 = (t13 = c(t13)).fill, n3 = t13.align, u2 = t13.sign, d2 = t13.symbol, y3 = t13.zero, m2 = t13.width, v2 = t13.comma, b2 = t13.precision, w2 = t13.trim, x2 = t13.type;
    x2 === "n" ? (v2 = true, x2 = "g") : p[x2] || (b2 === void 0 && (b2 = 12), w2 = true, x2 = "g"), (y3 || e3 === "0" && n3 === "=") && (y3 = true, e3 = "0", n3 = "=");
    var M2 = d2 === "$" ? i2 : d2 === "#" && /[boxX]/.test(x2) ? "0" + x2.toLowerCase() : "", S2 = d2 === "$" ? o2 : /[%p]/.test(x2) ? h2 : "", A2 = p[x2], O2 = /[defgprs%]/.test(x2);
    function N2(t14) {
      var i3, o3, c2, h3 = M2, p2 = S2;
      if (x2 === "c")
        p2 = A2(t14) + p2, t14 = "";
      else {
        var d3 = (t14 = +t14) < 0 || 1 / t14 < 0;
        if (t14 = isNaN(t14) ? g2 : A2(Math.abs(t14), b2), w2 && (t14 = function(t15) {
          t:
            for (var e4, n4 = t15.length, r3 = 1, i4 = -1; r3 < n4; ++r3)
              switch (t15[r3]) {
                case ".":
                  i4 = e4 = r3;
                  break;
                case "0":
                  i4 === 0 && (i4 = r3), e4 = r3;
                  break;
                default:
                  if (!+t15[r3])
                    break t;
                  i4 > 0 && (i4 = 0);
              }
          return i4 > 0 ? t15.slice(0, i4) + t15.slice(e4 + 1) : t15;
        }(t14)), d3 && +t14 == 0 && u2 !== "+" && (d3 = false), h3 = (d3 ? u2 === "(" ? u2 : f2 : u2 === "-" || u2 === "(" ? "" : u2) + h3, p2 = (x2 === "s" ? _[8 + s / 3] : "") + p2 + (d3 && u2 === "(" ? ")" : ""), O2) {
          for (i3 = -1, o3 = t14.length; ++i3 < o3; )
            if (48 > (c2 = t14.charCodeAt(i3)) || c2 > 57) {
              p2 = (c2 === 46 ? a2 + t14.slice(i3 + 1) : t14.slice(i3)) + p2, t14 = t14.slice(0, i3);
              break;
            }
        }
      }
      v2 && !y3 && (t14 = r2(t14, 1 / 0));
      var N3 = h3.length + t14.length + p2.length, k2 = N3 < m2 ? new Array(m2 - N3 + 1).join(e3) : "";
      switch (v2 && y3 && (t14 = r2(k2 + t14, k2.length ? m2 - p2.length : 1 / 0), k2 = ""), n3) {
        case "<":
          t14 = h3 + t14 + p2 + k2;
          break;
        case "=":
          t14 = h3 + k2 + t14 + p2;
          break;
        case "^":
          t14 = k2.slice(0, N3 = k2.length >> 1) + h3 + t14 + p2 + k2.slice(N3);
          break;
        default:
          t14 = k2 + h3 + t14 + p2;
      }
      return l2(t14);
    }
    return b2 = b2 === void 0 ? 6 : /[gprs]/.test(x2) ? Math.max(1, Math.min(21, b2)) : Math.max(0, Math.min(20, b2)), N2.toString = () => t13 + "", N2;
  }
  return { format: y2, formatPrefix: function(t13, e3) {
    var n3 = y2(((t13 = c(t13)).type = "f", t13)), r3 = 3 * Math.max(-8, Math.min(8, Math.floor(u(e3) / 3))), i3 = Math.pow(10, -r3), o3 = _[8 + r3 / 3];
    return (t14) => n3(i3 * t14) + o3;
  } };
}
g = b({ thousands: ",", grouping: [3], currency: ["$", ""] }), y = g.format, m = g.formatPrefix;
var w = "http://www.w3.org/1999/xhtml", x = { svg: "http://www.w3.org/2000/svg", xhtml: w, xlink: "http://www.w3.org/1999/xlink", xml: "http://www.w3.org/XML/1998/namespace", xmlns: "http://www.w3.org/2000/xmlns/" };
function M(t12) {
  var e2 = t12 += "", n2 = e2.indexOf(":");
  return n2 >= 0 && (e2 = t12.slice(0, n2)) !== "xmlns" && (t12 = t12.slice(n2 + 1)), x.hasOwnProperty(e2) ? { space: x[e2], local: t12 } : t12;
}
function S(t12) {
  return function() {
    var e2 = this.ownerDocument, n2 = this.namespaceURI;
    return n2 === w && e2.documentElement.namespaceURI === w ? e2.createElement(t12) : e2.createElementNS(n2, t12);
  };
}
function A(t12) {
  return function() {
    return this.ownerDocument.createElementNS(t12.space, t12.local);
  };
}
function O(t12) {
  var e2 = M(t12);
  return (e2.local ? A : S)(e2);
}
function N() {
}
function k(t12) {
  return t12 == null ? N : function() {
    return this.querySelector(t12);
  };
}
function E(t12) {
  return t12 == null ? [] : Array.isArray(t12) ? t12 : Array.from(t12);
}
function I() {
  return [];
}
function T(t12) {
  return t12 == null ? I : function() {
    return this.querySelectorAll(t12);
  };
}
function j(t12) {
  return function() {
    return this.matches(t12);
  };
}
function C(t12) {
  return (e2) => e2.matches(t12);
}
var $ = Array.prototype.find;
function R() {
  return this.firstElementChild;
}
var P = Array.prototype.filter;
function q() {
  return Array.from(this.children);
}
function L(t12) {
  return new Array(t12.length);
}
function V(t12, e2) {
  this.ownerDocument = t12.ownerDocument, this.namespaceURI = t12.namespaceURI, this._next = null, this._parent = t12, this.__data__ = e2;
}
function F(t12) {
  return () => t12;
}
function D(t12, e2, n2, r2, i2, o2) {
  for (var a2, u2 = 0, s2 = e2.length, l2 = o2.length; u2 < l2; ++u2)
    (a2 = e2[u2]) ? (a2.__data__ = o2[u2], r2[u2] = a2) : n2[u2] = new V(t12, o2[u2]);
  for (; u2 < s2; ++u2)
    (a2 = e2[u2]) && (i2[u2] = a2);
}
function z(t12, e2, n2, r2, i2, o2, a2) {
  var u2, s2, l2, c2 = /* @__PURE__ */ new Map(), h2 = e2.length, f2 = o2.length, p2 = new Array(h2);
  for (u2 = 0; u2 < h2; ++u2)
    (s2 = e2[u2]) && (p2[u2] = l2 = a2.call(s2, s2.__data__, u2, e2) + "", c2.has(l2) ? i2[u2] = s2 : c2.set(l2, s2));
  for (u2 = 0; u2 < f2; ++u2)
    l2 = a2.call(t12, o2[u2], u2, o2) + "", (s2 = c2.get(l2)) ? (r2[u2] = s2, s2.__data__ = o2[u2], c2.delete(l2)) : n2[u2] = new V(t12, o2[u2]);
  for (u2 = 0; u2 < h2; ++u2)
    (s2 = e2[u2]) && c2.get(p2[u2]) === s2 && (i2[u2] = s2);
}
function B(t12) {
  return t12.__data__;
}
function W(t12) {
  return typeof t12 == "object" && "length" in t12 ? t12 : Array.from(t12);
}
function H(t12, e2) {
  return t12 < e2 ? -1 : t12 > e2 ? 1 : t12 >= e2 ? 0 : NaN;
}
function U(t12) {
  return function() {
    this.removeAttribute(t12);
  };
}
function X(t12) {
  return function() {
    this.removeAttributeNS(t12.space, t12.local);
  };
}
function Q(t12, e2) {
  return function() {
    this.setAttribute(t12, e2);
  };
}
function Y(t12, e2) {
  return function() {
    this.setAttributeNS(t12.space, t12.local, e2);
  };
}
function G(t12, e2) {
  return function() {
    var n2 = e2.apply(this, arguments);
    n2 == null ? this.removeAttribute(t12) : this.setAttribute(t12, n2);
  };
}
function Z(t12, e2) {
  return function() {
    var n2 = e2.apply(this, arguments);
    n2 == null ? this.removeAttributeNS(t12.space, t12.local) : this.setAttributeNS(t12.space, t12.local, n2);
  };
}
function K(t12) {
  return t12.ownerDocument && t12.ownerDocument.defaultView || t12.document && t12 || t12.defaultView;
}
function J(t12) {
  return function() {
    this.style.removeProperty(t12);
  };
}
function tt(t12, e2, n2) {
  return function() {
    this.style.setProperty(t12, e2, n2);
  };
}
function et(t12, e2, n2) {
  return function() {
    var r2 = e2.apply(this, arguments);
    r2 == null ? this.style.removeProperty(t12) : this.style.setProperty(t12, r2, n2);
  };
}
function nt(t12, e2) {
  return t12.style.getPropertyValue(e2) || K(t12).getComputedStyle(t12, null).getPropertyValue(e2);
}
function rt(t12) {
  return function() {
    delete this[t12];
  };
}
function it(t12, e2) {
  return function() {
    this[t12] = e2;
  };
}
function ot(t12, e2) {
  return function() {
    var n2 = e2.apply(this, arguments);
    n2 == null ? delete this[t12] : this[t12] = n2;
  };
}
function at(t12) {
  return t12.trim().split(/^|\s+/);
}
function ut(t12) {
  return t12.classList || new st(t12);
}
function st(t12) {
  this._node = t12, this._names = at(t12.getAttribute("class") || "");
}
function lt(t12, e2) {
  for (var n2 = ut(t12), r2 = -1, i2 = e2.length; ++r2 < i2; )
    n2.add(e2[r2]);
}
function ct(t12, e2) {
  for (var n2 = ut(t12), r2 = -1, i2 = e2.length; ++r2 < i2; )
    n2.remove(e2[r2]);
}
function ht(t12) {
  return function() {
    lt(this, t12);
  };
}
function ft(t12) {
  return function() {
    ct(this, t12);
  };
}
function pt(t12, e2) {
  return function() {
    (e2.apply(this, arguments) ? lt : ct)(this, t12);
  };
}
function dt() {
  this.textContent = "";
}
function gt(t12) {
  return function() {
    this.textContent = t12;
  };
}
function yt(t12) {
  return function() {
    var e2 = t12.apply(this, arguments);
    this.textContent = e2 != null ? e2 : "";
  };
}
function mt() {
  this.innerHTML = "";
}
function vt(t12) {
  return function() {
    this.innerHTML = t12;
  };
}
function _t(t12) {
  return function() {
    var e2 = t12.apply(this, arguments);
    this.innerHTML = e2 != null ? e2 : "";
  };
}
function bt() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function wt() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function xt() {
  return null;
}
function Mt() {
  var t12 = this.parentNode;
  t12 && t12.removeChild(this);
}
function St() {
  var t12 = this.cloneNode(false), e2 = this.parentNode;
  return e2 ? e2.insertBefore(t12, this.nextSibling) : t12;
}
function At() {
  var t12 = this.cloneNode(true), e2 = this.parentNode;
  return e2 ? e2.insertBefore(t12, this.nextSibling) : t12;
}
function Ot(t12) {
  return t12.trim().split(/^|\s+/).map((t13) => {
    var e2 = "", n2 = t13.indexOf(".");
    return n2 >= 0 && (e2 = t13.slice(n2 + 1), t13 = t13.slice(0, n2)), { type: t13, name: e2 };
  });
}
function Nt(t12) {
  return function() {
    var e2 = this.__on;
    if (e2) {
      for (var n2, r2 = 0, i2 = -1, o2 = e2.length; r2 < o2; ++r2)
        n2 = e2[r2], t12.type && n2.type !== t12.type || n2.name !== t12.name ? e2[++i2] = n2 : this.removeEventListener(n2.type, n2.listener, n2.options);
      ++i2 ? e2.length = i2 : delete this.__on;
    }
  };
}
function kt(t12, e2, n2) {
  return function() {
    var r2, i2 = this.__on, o2 = function(t13) {
      return function(e3) {
        t13.call(this, e3, this.__data__);
      };
    }(e2);
    if (i2) {
      for (var a2 = 0, u2 = i2.length; a2 < u2; ++a2)
        if ((r2 = i2[a2]).type === t12.type && r2.name === t12.name)
          return this.removeEventListener(r2.type, r2.listener, r2.options), this.addEventListener(r2.type, r2.listener = o2, r2.options = n2), void (r2.value = e2);
    }
    this.addEventListener(t12.type, o2, n2), r2 = { type: t12.type, name: t12.name, value: e2, listener: o2, options: n2 }, i2 ? i2.push(r2) : this.__on = [r2];
  };
}
function Et(t12, e2, n2) {
  var r2 = K(t12), i2 = r2.CustomEvent;
  typeof i2 == "function" ? i2 = new i2(e2, n2) : (i2 = r2.document.createEvent("Event"), n2 ? (i2.initEvent(e2, n2.bubbles, n2.cancelable), i2.detail = n2.detail) : i2.initEvent(e2, false, false)), t12.dispatchEvent(i2);
}
function It(t12, e2) {
  return function() {
    return Et(this, t12, e2);
  };
}
function Tt(t12, e2) {
  return function() {
    return Et(this, t12, e2.apply(this, arguments));
  };
}
V.prototype = { constructor: V, appendChild: function(t12) {
  return this._parent.insertBefore(t12, this._next);
}, insertBefore: function(t12, e2) {
  return this._parent.insertBefore(t12, e2);
}, querySelector: function(t12) {
  return this._parent.querySelector(t12);
}, querySelectorAll: function(t12) {
  return this._parent.querySelectorAll(t12);
} }, st.prototype = { add: function(t12) {
  this._names.indexOf(t12) < 0 && (this._names.push(t12), this._node.setAttribute("class", this._names.join(" ")));
}, remove: function(t12) {
  var e2 = this._names.indexOf(t12);
  e2 >= 0 && (this._names.splice(e2, 1), this._node.setAttribute("class", this._names.join(" ")));
}, contains: function(t12) {
  return this._names.indexOf(t12) >= 0;
} };
var jt = [null];
function Ct(t12, e2) {
  this._groups = t12, this._parents = e2;
}
function $t() {
  return new Ct([[document.documentElement]], jt);
}
function Rt(t12) {
  return typeof t12 == "string" ? new Ct([[document.querySelector(t12)]], [document.documentElement]) : new Ct([[t12]], jt);
}
function Pt(t12, e2) {
  return t12 == null || e2 == null ? NaN : t12 < e2 ? -1 : t12 > e2 ? 1 : t12 >= e2 ? 0 : NaN;
}
function qt(t12) {
  let e2 = t12, n2 = t12, r2 = t12;
  function i2(t13, e3, i3 = 0, o2 = t13.length) {
    if (i3 < o2) {
      if (n2(e3, e3) !== 0)
        return o2;
      do {
        const n3 = i3 + o2 >>> 1;
        r2(t13[n3], e3) < 0 ? i3 = n3 + 1 : o2 = n3;
      } while (i3 < o2);
    }
    return i3;
  }
  return t12.length !== 2 && (e2 = (e3, n3) => t12(e3) - n3, n2 = Pt, r2 = (e3, n3) => Pt(t12(e3), n3)), { left: i2, center: function(t13, n3, r3 = 0, o2 = t13.length) {
    const a2 = i2(t13, n3, r3, o2 - 1);
    return a2 > r3 && e2(t13[a2 - 1], n3) > -e2(t13[a2], n3) ? a2 - 1 : a2;
  }, right: function(t13, e3, i3 = 0, o2 = t13.length) {
    if (i3 < o2) {
      if (n2(e3, e3) !== 0)
        return o2;
      do {
        const n3 = i3 + o2 >>> 1;
        r2(t13[n3], e3) <= 0 ? i3 = n3 + 1 : o2 = n3;
      } while (i3 < o2);
    }
    return i3;
  } };
}
Ct.prototype = $t.prototype = { constructor: Ct, select: function(t12) {
  typeof t12 != "function" && (t12 = k(t12));
  for (var e2 = this._groups, n2 = e2.length, r2 = new Array(n2), i2 = 0; i2 < n2; ++i2)
    for (var o2, a2, u2 = e2[i2], s2 = u2.length, l2 = r2[i2] = new Array(s2), c2 = 0; c2 < s2; ++c2)
      (o2 = u2[c2]) && (a2 = t12.call(o2, o2.__data__, c2, u2)) && ("__data__" in o2 && (a2.__data__ = o2.__data__), l2[c2] = a2);
  return new Ct(r2, this._parents);
}, selectAll: function(t12) {
  t12 = typeof t12 == "function" ? function(t13) {
    return function() {
      return E(t13.apply(this, arguments));
    };
  }(t12) : T(t12);
  for (var e2 = this._groups, n2 = e2.length, r2 = [], i2 = [], o2 = 0; o2 < n2; ++o2)
    for (var a2, u2 = e2[o2], s2 = u2.length, l2 = 0; l2 < s2; ++l2)
      (a2 = u2[l2]) && (r2.push(t12.call(a2, a2.__data__, l2, u2)), i2.push(a2));
  return new Ct(r2, i2);
}, selectChild: function(t12) {
  return this.select(t12 == null ? R : function(t13) {
    return function() {
      return $.call(this.children, t13);
    };
  }(typeof t12 == "function" ? t12 : C(t12)));
}, selectChildren: function(t12) {
  return this.selectAll(t12 == null ? q : function(t13) {
    return function() {
      return P.call(this.children, t13);
    };
  }(typeof t12 == "function" ? t12 : C(t12)));
}, filter: function(t12) {
  typeof t12 != "function" && (t12 = j(t12));
  for (var e2 = this._groups, n2 = e2.length, r2 = new Array(n2), i2 = 0; i2 < n2; ++i2)
    for (var o2, a2 = e2[i2], u2 = a2.length, s2 = r2[i2] = [], l2 = 0; l2 < u2; ++l2)
      (o2 = a2[l2]) && t12.call(o2, o2.__data__, l2, a2) && s2.push(o2);
  return new Ct(r2, this._parents);
}, data: function(t12, e2) {
  if (!arguments.length)
    return Array.from(this, B);
  var n2 = e2 ? z : D, r2 = this._parents, i2 = this._groups;
  typeof t12 != "function" && (t12 = F(t12));
  for (var o2 = i2.length, a2 = new Array(o2), u2 = new Array(o2), s2 = new Array(o2), l2 = 0; l2 < o2; ++l2) {
    var c2 = r2[l2], h2 = i2[l2], f2 = h2.length, p2 = W(t12.call(c2, c2 && c2.__data__, l2, r2)), d2 = p2.length, g2 = u2[l2] = new Array(d2), y2 = a2[l2] = new Array(d2), m2 = s2[l2] = new Array(f2);
    n2(c2, h2, g2, y2, m2, p2, e2);
    for (var v2, _2, b2 = 0, w2 = 0; b2 < d2; ++b2)
      if (v2 = g2[b2]) {
        for (b2 >= w2 && (w2 = b2 + 1); !(_2 = y2[w2]) && ++w2 < d2; )
          ;
        v2._next = _2 || null;
      }
  }
  return (a2 = new Ct(a2, r2))._enter = u2, a2._exit = s2, a2;
}, enter: function() {
  return new Ct(this._enter || this._groups.map(L), this._parents);
}, exit: function() {
  return new Ct(this._exit || this._groups.map(L), this._parents);
}, join: function(t12, e2, n2) {
  var r2 = this.enter(), i2 = this, o2 = this.exit();
  return typeof t12 == "function" ? (r2 = t12(r2)) && (r2 = r2.selection()) : r2 = r2.append(t12 + ""), e2 != null && (i2 = e2(i2)) && (i2 = i2.selection()), n2 == null ? o2.remove() : n2(o2), r2 && i2 ? r2.merge(i2).order() : i2;
}, merge: function(t12) {
  for (var e2 = t12.selection ? t12.selection() : t12, n2 = this._groups, r2 = e2._groups, i2 = n2.length, o2 = r2.length, a2 = Math.min(i2, o2), u2 = new Array(i2), s2 = 0; s2 < a2; ++s2)
    for (var l2, c2 = n2[s2], h2 = r2[s2], f2 = c2.length, p2 = u2[s2] = new Array(f2), d2 = 0; d2 < f2; ++d2)
      (l2 = c2[d2] || h2[d2]) && (p2[d2] = l2);
  for (; s2 < i2; ++s2)
    u2[s2] = n2[s2];
  return new Ct(u2, this._parents);
}, selection: function() {
  return this;
}, order: function() {
  for (var t12 = this._groups, e2 = -1, n2 = t12.length; ++e2 < n2; )
    for (var r2, i2 = t12[e2], o2 = i2.length - 1, a2 = i2[o2]; --o2 >= 0; )
      (r2 = i2[o2]) && (a2 && 4 ^ r2.compareDocumentPosition(a2) && a2.parentNode.insertBefore(r2, a2), a2 = r2);
  return this;
}, sort: function(t12) {
  function e2(e3, n3) {
    return e3 && n3 ? t12(e3.__data__, n3.__data__) : !e3 - !n3;
  }
  t12 || (t12 = H);
  for (var n2 = this._groups, r2 = n2.length, i2 = new Array(r2), o2 = 0; o2 < r2; ++o2) {
    for (var a2, u2 = n2[o2], s2 = u2.length, l2 = i2[o2] = new Array(s2), c2 = 0; c2 < s2; ++c2)
      (a2 = u2[c2]) && (l2[c2] = a2);
    l2.sort(e2);
  }
  return new Ct(i2, this._parents).order();
}, call: function() {
  var t12 = arguments[0];
  return arguments[0] = this, t12.apply(null, arguments), this;
}, nodes: function() {
  return Array.from(this);
}, node: function() {
  for (var t12 = this._groups, e2 = 0, n2 = t12.length; e2 < n2; ++e2)
    for (var r2 = t12[e2], i2 = 0, o2 = r2.length; i2 < o2; ++i2) {
      var a2 = r2[i2];
      if (a2)
        return a2;
    }
  return null;
}, size: function() {
  let t12 = 0;
  for (const e2 of this)
    ++t12;
  return t12;
}, empty: function() {
  return !this.node();
}, each: function(t12) {
  for (var e2 = this._groups, n2 = 0, r2 = e2.length; n2 < r2; ++n2)
    for (var i2, o2 = e2[n2], a2 = 0, u2 = o2.length; a2 < u2; ++a2)
      (i2 = o2[a2]) && t12.call(i2, i2.__data__, a2, o2);
  return this;
}, attr: function(t12, e2) {
  var n2 = M(t12);
  if (arguments.length < 2) {
    var r2 = this.node();
    return n2.local ? r2.getAttributeNS(n2.space, n2.local) : r2.getAttribute(n2);
  }
  return this.each((e2 == null ? n2.local ? X : U : typeof e2 == "function" ? n2.local ? Z : G : n2.local ? Y : Q)(n2, e2));
}, style: function(t12, e2, n2) {
  return arguments.length > 1 ? this.each((e2 == null ? J : typeof e2 == "function" ? et : tt)(t12, e2, n2 != null ? n2 : "")) : nt(this.node(), t12);
}, property: function(t12, e2) {
  return arguments.length > 1 ? this.each((e2 == null ? rt : typeof e2 == "function" ? ot : it)(t12, e2)) : this.node()[t12];
}, classed: function(t12, e2) {
  var n2 = at(t12 + "");
  if (arguments.length < 2) {
    for (var r2 = ut(this.node()), i2 = -1, o2 = n2.length; ++i2 < o2; )
      if (!r2.contains(n2[i2]))
        return false;
    return true;
  }
  return this.each((typeof e2 == "function" ? pt : e2 ? ht : ft)(n2, e2));
}, text: function(t12) {
  return arguments.length ? this.each(t12 == null ? dt : (typeof t12 == "function" ? yt : gt)(t12)) : this.node().textContent;
}, html: function(t12) {
  return arguments.length ? this.each(t12 == null ? mt : (typeof t12 == "function" ? _t : vt)(t12)) : this.node().innerHTML;
}, raise: function() {
  return this.each(bt);
}, lower: function() {
  return this.each(wt);
}, append: function(t12) {
  var e2 = typeof t12 == "function" ? t12 : O(t12);
  return this.select(function() {
    return this.appendChild(e2.apply(this, arguments));
  });
}, insert: function(t12, e2) {
  var n2 = typeof t12 == "function" ? t12 : O(t12), r2 = e2 == null ? xt : typeof e2 == "function" ? e2 : k(e2);
  return this.select(function() {
    return this.insertBefore(n2.apply(this, arguments), r2.apply(this, arguments) || null);
  });
}, remove: function() {
  return this.each(Mt);
}, clone: function(t12) {
  return this.select(t12 ? At : St);
}, datum: function(t12) {
  return arguments.length ? this.property("__data__", t12) : this.node().__data__;
}, on: function(t12, e2, n2) {
  var r2, i2, o2 = Ot(t12 + ""), a2 = o2.length;
  if (!(arguments.length < 2)) {
    for (u2 = e2 ? kt : Nt, r2 = 0; r2 < a2; ++r2)
      this.each(u2(o2[r2], e2, n2));
    return this;
  }
  var u2 = this.node().__on;
  if (u2) {
    for (var s2, l2 = 0, c2 = u2.length; l2 < c2; ++l2)
      for (r2 = 0, s2 = u2[l2]; r2 < a2; ++r2)
        if ((i2 = o2[r2]).type === s2.type && i2.name === s2.name)
          return s2.value;
  }
}, dispatch: function(t12, e2) {
  return this.each((typeof e2 == "function" ? Tt : It)(t12, e2));
}, [Symbol.iterator]: function* () {
  for (var t12 = this._groups, e2 = 0, n2 = t12.length; e2 < n2; ++e2)
    for (var r2, i2 = t12[e2], o2 = 0, a2 = i2.length; o2 < a2; ++o2)
      (r2 = i2[o2]) && (yield r2);
} };
const Lt = qt(Pt).right;
qt(function(t12) {
  return t12 === null ? NaN : +t12;
}).center;
var Vt = Lt, Ft = Math.sqrt(50), Dt = Math.sqrt(10), zt = Math.sqrt(2);
function Bt(t12, e2, n2) {
  var r2 = (e2 - t12) / Math.max(0, n2), i2 = Math.floor(Math.log(r2) / Math.LN10), o2 = r2 / Math.pow(10, i2);
  return i2 >= 0 ? (o2 >= Ft ? 10 : o2 >= Dt ? 5 : o2 >= zt ? 2 : 1) * Math.pow(10, i2) : -Math.pow(10, -i2) / (o2 >= Ft ? 10 : o2 >= Dt ? 5 : o2 >= zt ? 2 : 1);
}
function Wt(t12, e2) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t12);
      break;
    default:
      this.range(e2).domain(t12);
  }
  return this;
}
function Ht(t12, e2, n2) {
  t12.prototype = e2.prototype = n2, n2.constructor = t12;
}
function Ut(t12, e2) {
  var n2 = Object.create(t12.prototype);
  for (var r2 in e2)
    n2[r2] = e2[r2];
  return n2;
}
function Xt() {
}
var Qt = 1 / 0.7, Yt = "\\s*([+-]?\\d+)\\s*", Gt = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Zt = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Kt = /^#([0-9a-f]{3,8})$/, Jt = new RegExp(`^rgb\\(${Yt},${Yt},${Yt}\\)$`), te = new RegExp(`^rgb\\(${Zt},${Zt},${Zt}\\)$`), ee = new RegExp(`^rgba\\(${Yt},${Yt},${Yt},${Gt}\\)$`), ne = new RegExp(`^rgba\\(${Zt},${Zt},${Zt},${Gt}\\)$`), re = new RegExp(`^hsl\\(${Gt},${Zt},${Zt}\\)$`), ie = new RegExp(`^hsla\\(${Gt},${Zt},${Zt},${Gt}\\)$`), oe = { aliceblue: 15792383, antiquewhite: 16444375, aqua: 65535, aquamarine: 8388564, azure: 15794175, beige: 16119260, bisque: 16770244, black: 0, blanchedalmond: 16772045, blue: 255, blueviolet: 9055202, brown: 10824234, burlywood: 14596231, cadetblue: 6266528, chartreuse: 8388352, chocolate: 13789470, coral: 16744272, cornflowerblue: 6591981, cornsilk: 16775388, crimson: 14423100, cyan: 65535, darkblue: 139, darkcyan: 35723, darkgoldenrod: 12092939, darkgray: 11119017, darkgreen: 25600, darkgrey: 11119017, darkkhaki: 12433259, darkmagenta: 9109643, darkolivegreen: 5597999, darkorange: 16747520, darkorchid: 10040012, darkred: 9109504, darksalmon: 15308410, darkseagreen: 9419919, darkslateblue: 4734347, darkslategray: 3100495, darkslategrey: 3100495, darkturquoise: 52945, darkviolet: 9699539, deeppink: 16716947, deepskyblue: 49151, dimgray: 6908265, dimgrey: 6908265, dodgerblue: 2003199, firebrick: 11674146, floralwhite: 16775920, forestgreen: 2263842, fuchsia: 16711935, gainsboro: 14474460, ghostwhite: 16316671, gold: 16766720, goldenrod: 14329120, gray: 8421504, green: 32768, greenyellow: 11403055, grey: 8421504, honeydew: 15794160, hotpink: 16738740, indianred: 13458524, indigo: 4915330, ivory: 16777200, khaki: 15787660, lavender: 15132410, lavenderblush: 16773365, lawngreen: 8190976, lemonchiffon: 16775885, lightblue: 11393254, lightcoral: 15761536, lightcyan: 14745599, lightgoldenrodyellow: 16448210, lightgray: 13882323, lightgreen: 9498256, lightgrey: 13882323, lightpink: 16758465, lightsalmon: 16752762, lightseagreen: 2142890, lightskyblue: 8900346, lightslategray: 7833753, lightslategrey: 7833753, lightsteelblue: 11584734, lightyellow: 16777184, lime: 65280, limegreen: 3329330, linen: 16445670, magenta: 16711935, maroon: 8388608, mediumaquamarine: 6737322, mediumblue: 205, mediumorchid: 12211667, mediumpurple: 9662683, mediumseagreen: 3978097, mediumslateblue: 8087790, mediumspringgreen: 64154, mediumturquoise: 4772300, mediumvioletred: 13047173, midnightblue: 1644912, mintcream: 16121850, mistyrose: 16770273, moccasin: 16770229, navajowhite: 16768685, navy: 128, oldlace: 16643558, olive: 8421376, olivedrab: 7048739, orange: 16753920, orangered: 16729344, orchid: 14315734, palegoldenrod: 15657130, palegreen: 10025880, paleturquoise: 11529966, palevioletred: 14381203, papayawhip: 16773077, peachpuff: 16767673, peru: 13468991, pink: 16761035, plum: 14524637, powderblue: 11591910, purple: 8388736, rebeccapurple: 6697881, red: 16711680, rosybrown: 12357519, royalblue: 4286945, saddlebrown: 9127187, salmon: 16416882, sandybrown: 16032864, seagreen: 3050327, seashell: 16774638, sienna: 10506797, silver: 12632256, skyblue: 8900331, slateblue: 6970061, slategray: 7372944, slategrey: 7372944, snow: 16775930, springgreen: 65407, steelblue: 4620980, tan: 13808780, teal: 32896, thistle: 14204888, tomato: 16737095, turquoise: 4251856, violet: 15631086, wheat: 16113331, white: 16777215, whitesmoke: 16119285, yellow: 16776960, yellowgreen: 10145074 };
function ae() {
  return this.rgb().formatHex();
}
function ue() {
  return this.rgb().formatRgb();
}
function se(t12) {
  var e2, n2;
  return t12 = (t12 + "").trim().toLowerCase(), (e2 = Kt.exec(t12)) ? (n2 = e2[1].length, e2 = parseInt(e2[1], 16), n2 === 6 ? le(e2) : n2 === 3 ? new pe(e2 >> 8 & 15 | e2 >> 4 & 240, e2 >> 4 & 15 | 240 & e2, (15 & e2) << 4 | 15 & e2, 1) : n2 === 8 ? ce(e2 >> 24 & 255, e2 >> 16 & 255, e2 >> 8 & 255, (255 & e2) / 255) : n2 === 4 ? ce(e2 >> 12 & 15 | e2 >> 8 & 240, e2 >> 8 & 15 | e2 >> 4 & 240, e2 >> 4 & 15 | 240 & e2, ((15 & e2) << 4 | 15 & e2) / 255) : null) : (e2 = Jt.exec(t12)) ? new pe(e2[1], e2[2], e2[3], 1) : (e2 = te.exec(t12)) ? new pe(255 * e2[1] / 100, 255 * e2[2] / 100, 255 * e2[3] / 100, 1) : (e2 = ee.exec(t12)) ? ce(e2[1], e2[2], e2[3], e2[4]) : (e2 = ne.exec(t12)) ? ce(255 * e2[1] / 100, 255 * e2[2] / 100, 255 * e2[3] / 100, e2[4]) : (e2 = re.exec(t12)) ? _e(e2[1], e2[2] / 100, e2[3] / 100, 1) : (e2 = ie.exec(t12)) ? _e(e2[1], e2[2] / 100, e2[3] / 100, e2[4]) : oe.hasOwnProperty(t12) ? le(oe[t12]) : t12 === "transparent" ? new pe(NaN, NaN, NaN, 0) : null;
}
function le(t12) {
  return new pe(t12 >> 16 & 255, t12 >> 8 & 255, 255 & t12, 1);
}
function ce(t12, e2, n2, r2) {
  return r2 <= 0 && (t12 = e2 = n2 = NaN), new pe(t12, e2, n2, r2);
}
function he(t12) {
  return t12 instanceof Xt || (t12 = se(t12)), t12 ? new pe((t12 = t12.rgb()).r, t12.g, t12.b, t12.opacity) : new pe();
}
function fe(t12, e2, n2, r2) {
  return arguments.length === 1 ? he(t12) : new pe(t12, e2, n2, r2 != null ? r2 : 1);
}
function pe(t12, e2, n2, r2) {
  this.r = +t12, this.g = +e2, this.b = +n2, this.opacity = +r2;
}
function de() {
  return `#${ve(this.r)}${ve(this.g)}${ve(this.b)}`;
}
function ge() {
  const t12 = ye(this.opacity);
  return `${t12 === 1 ? "rgb(" : "rgba("}${me(this.r)}, ${me(this.g)}, ${me(this.b)}${t12 === 1 ? ")" : `, ${t12})`}`;
}
function ye(t12) {
  return isNaN(t12) ? 1 : Math.max(0, Math.min(1, t12));
}
function me(t12) {
  return Math.max(0, Math.min(255, Math.round(t12) || 0));
}
function ve(t12) {
  return ((t12 = me(t12)) < 16 ? "0" : "") + t12.toString(16);
}
function _e(t12, e2, n2, r2) {
  return r2 <= 0 ? t12 = e2 = n2 = NaN : n2 <= 0 || n2 >= 1 ? t12 = e2 = NaN : e2 <= 0 && (t12 = NaN), new xe(t12, e2, n2, r2);
}
function be(t12) {
  if (t12 instanceof xe)
    return new xe(t12.h, t12.s, t12.l, t12.opacity);
  if (t12 instanceof Xt || (t12 = se(t12)), !t12)
    return new xe();
  if (t12 instanceof xe)
    return t12;
  var e2 = (t12 = t12.rgb()).r / 255, n2 = t12.g / 255, r2 = t12.b / 255, i2 = Math.min(e2, n2, r2), o2 = Math.max(e2, n2, r2), a2 = NaN, u2 = o2 - i2, s2 = (o2 + i2) / 2;
  return u2 ? (a2 = e2 === o2 ? (n2 - r2) / u2 + 6 * (n2 < r2) : n2 === o2 ? (r2 - e2) / u2 + 2 : (e2 - n2) / u2 + 4, u2 /= s2 < 0.5 ? o2 + i2 : 2 - o2 - i2, a2 *= 60) : u2 = s2 > 0 && s2 < 1 ? 0 : a2, new xe(a2, u2, s2, t12.opacity);
}
function we(t12, e2, n2, r2) {
  return arguments.length === 1 ? be(t12) : new xe(t12, e2, n2, r2 != null ? r2 : 1);
}
function xe(t12, e2, n2, r2) {
  this.h = +t12, this.s = +e2, this.l = +n2, this.opacity = +r2;
}
function Me(t12) {
  return (t12 = (t12 || 0) % 360) < 0 ? t12 + 360 : t12;
}
function Se(t12) {
  return Math.max(0, Math.min(1, t12 || 0));
}
function Ae(t12, e2, n2) {
  return 255 * (t12 < 60 ? e2 + (n2 - e2) * t12 / 60 : t12 < 180 ? n2 : t12 < 240 ? e2 + (n2 - e2) * (240 - t12) / 60 : e2);
}
Ht(Xt, se, { copy(t12) {
  return Object.assign(new this.constructor(), this, t12);
}, displayable() {
  return this.rgb().displayable();
}, hex: ae, formatHex: ae, formatHex8: function() {
  return this.rgb().formatHex8();
}, formatHsl: function() {
  return be(this).formatHsl();
}, formatRgb: ue, toString: ue }), Ht(pe, fe, Ut(Xt, { brighter(t12) {
  return t12 = t12 == null ? Qt : Math.pow(Qt, t12), new pe(this.r * t12, this.g * t12, this.b * t12, this.opacity);
}, darker(t12) {
  return t12 = t12 == null ? 0.7 : Math.pow(0.7, t12), new pe(this.r * t12, this.g * t12, this.b * t12, this.opacity);
}, rgb() {
  return this;
}, clamp() {
  return new pe(me(this.r), me(this.g), me(this.b), ye(this.opacity));
}, displayable() {
  return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
}, hex: de, formatHex: de, formatHex8: function() {
  return `#${ve(this.r)}${ve(this.g)}${ve(this.b)}${ve(255 * (isNaN(this.opacity) ? 1 : this.opacity))}`;
}, formatRgb: ge, toString: ge })), Ht(xe, we, Ut(Xt, { brighter(t12) {
  return t12 = t12 == null ? Qt : Math.pow(Qt, t12), new xe(this.h, this.s, this.l * t12, this.opacity);
}, darker(t12) {
  return t12 = t12 == null ? 0.7 : Math.pow(0.7, t12), new xe(this.h, this.s, this.l * t12, this.opacity);
}, rgb() {
  var t12 = this.h % 360 + 360 * (this.h < 0), e2 = isNaN(t12) || isNaN(this.s) ? 0 : this.s, n2 = this.l, r2 = n2 + (n2 < 0.5 ? n2 : 1 - n2) * e2, i2 = 2 * n2 - r2;
  return new pe(Ae(t12 >= 240 ? t12 - 240 : t12 + 120, i2, r2), Ae(t12, i2, r2), Ae(t12 < 120 ? t12 + 240 : t12 - 120, i2, r2), this.opacity);
}, clamp() {
  return new xe(Me(this.h), Se(this.s), Se(this.l), ye(this.opacity));
}, displayable() {
  return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
}, formatHsl() {
  const t12 = ye(this.opacity);
  return `${t12 === 1 ? "hsl(" : "hsla("}${Me(this.h)}, ${100 * Se(this.s)}%, ${100 * Se(this.l)}%${t12 === 1 ? ")" : `, ${t12})`}`;
} }));
var Oe = (t12) => () => t12;
function Ne(t12, e2) {
  return (n2) => t12 + n2 * e2;
}
function ke(t12) {
  return (t12 = +t12) == 1 ? Ee : (e2, n2) => n2 - e2 ? function(t13, e3, n3) {
    return t13 = Math.pow(t13, n3), e3 = Math.pow(e3, n3) - t13, n3 = 1 / n3, (r2) => Math.pow(t13 + r2 * e3, n3);
  }(e2, n2, t12) : Oe(isNaN(e2) ? n2 : e2);
}
function Ee(t12, e2) {
  var n2 = e2 - t12;
  return n2 ? Ne(t12, n2) : Oe(isNaN(t12) ? e2 : t12);
}
var Ie = function t2(e2) {
  var n2 = ke(e2);
  function r2(t12, e3) {
    var r3 = n2((t12 = fe(t12)).r, (e3 = fe(e3)).r), i2 = n2(t12.g, e3.g), o2 = n2(t12.b, e3.b), a2 = Ee(t12.opacity, e3.opacity);
    return (e4) => (t12.r = r3(e4), t12.g = i2(e4), t12.b = o2(e4), t12.opacity = a2(e4), t12 + "");
  }
  return r2.gamma = t2, r2;
}(1);
function Te(t12, e2) {
  e2 || (e2 = []);
  var n2, r2 = t12 ? Math.min(e2.length, t12.length) : 0, i2 = e2.slice();
  return (o2) => {
    for (n2 = 0; n2 < r2; ++n2)
      i2[n2] = t12[n2] * (1 - o2) + e2[n2] * o2;
    return i2;
  };
}
function je(t12, e2) {
  var n2, r2 = e2 ? e2.length : 0, i2 = t12 ? Math.min(r2, t12.length) : 0, o2 = new Array(i2), a2 = new Array(r2);
  for (n2 = 0; n2 < i2; ++n2)
    o2[n2] = Ve(t12[n2], e2[n2]);
  for (; n2 < r2; ++n2)
    a2[n2] = e2[n2];
  return (t13) => {
    for (n2 = 0; n2 < i2; ++n2)
      a2[n2] = o2[n2](t13);
    return a2;
  };
}
function Ce(t12, e2) {
  var n2 = new Date();
  return t12 = +t12, e2 = +e2, (r2) => (n2.setTime(t12 * (1 - r2) + e2 * r2), n2);
}
function $e(t12, e2) {
  return t12 = +t12, e2 = +e2, (n2) => t12 * (1 - n2) + e2 * n2;
}
function Re(t12, e2) {
  var n2, r2 = {}, i2 = {};
  for (n2 in t12 !== null && typeof t12 == "object" || (t12 = {}), e2 !== null && typeof e2 == "object" || (e2 = {}), e2)
    n2 in t12 ? r2[n2] = Ve(t12[n2], e2[n2]) : i2[n2] = e2[n2];
  return (t13) => {
    for (n2 in r2)
      i2[n2] = r2[n2](t13);
    return i2;
  };
}
var Pe = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, qe = new RegExp(Pe.source, "g");
function Le(t12, e2) {
  var n2, r2, i2, o2 = Pe.lastIndex = qe.lastIndex = 0, a2 = -1, u2 = [], s2 = [];
  for (t12 += "", e2 += ""; (n2 = Pe.exec(t12)) && (r2 = qe.exec(e2)); )
    (i2 = r2.index) > o2 && (i2 = e2.slice(o2, i2), u2[a2] ? u2[a2] += i2 : u2[++a2] = i2), (n2 = n2[0]) === (r2 = r2[0]) ? u2[a2] ? u2[a2] += r2 : u2[++a2] = r2 : (u2[++a2] = null, s2.push({ i: a2, x: $e(n2, r2) })), o2 = qe.lastIndex;
  return o2 < e2.length && (i2 = e2.slice(o2), u2[a2] ? u2[a2] += i2 : u2[++a2] = i2), u2.length < 2 ? s2[0] ? function(t13) {
    return (e3) => t13(e3) + "";
  }(s2[0].x) : function(t13) {
    return () => t13;
  }(e2) : (e2 = s2.length, (t13) => {
    for (var n3, r3 = 0; r3 < e2; ++r3)
      u2[(n3 = s2[r3]).i] = n3.x(t13);
    return u2.join("");
  });
}
function Ve(t12, e2) {
  var n2, r2 = typeof e2;
  return e2 == null || r2 === "boolean" ? Oe(e2) : (r2 === "number" ? $e : r2 === "string" ? (n2 = se(e2)) ? (e2 = n2, Ie) : Le : e2 instanceof se ? Ie : e2 instanceof Date ? Ce : function(t13) {
    return ArrayBuffer.isView(t13) && !(t13 instanceof DataView);
  }(e2) ? Te : Array.isArray(e2) ? je : typeof e2.valueOf != "function" && typeof e2.toString != "function" || isNaN(e2) ? Re : $e)(t12, e2);
}
function Fe(t12, e2) {
  return t12 = +t12, e2 = +e2, (n2) => Math.round(t12 * (1 - n2) + e2 * n2);
}
var De, ze = 180 / Math.PI, Be = { translateX: 0, translateY: 0, rotate: 0, skewX: 0, scaleX: 1, scaleY: 1 };
function We(t12, e2, n2, r2, i2, o2) {
  var a2, u2, s2;
  return (a2 = Math.sqrt(t12 * t12 + e2 * e2)) && (t12 /= a2, e2 /= a2), (s2 = t12 * n2 + e2 * r2) && (n2 -= t12 * s2, r2 -= e2 * s2), (u2 = Math.sqrt(n2 * n2 + r2 * r2)) && (n2 /= u2, r2 /= u2, s2 /= u2), t12 * r2 < e2 * n2 && (t12 = -t12, e2 = -e2, s2 = -s2, a2 = -a2), { translateX: i2, translateY: o2, rotate: Math.atan2(e2, t12) * ze, skewX: Math.atan(s2) * ze, scaleX: a2, scaleY: u2 };
}
function He(t12, e2, n2, r2) {
  function i2(t13) {
    return t13.length ? t13.pop() + " " : "";
  }
  return (o2, a2) => {
    var u2 = [], s2 = [];
    return o2 = t12(o2), a2 = t12(a2), function(t13, r3, i3, o3, a3, u3) {
      if (t13 !== i3 || r3 !== o3) {
        var s3 = a3.push("translate(", null, e2, null, n2);
        u3.push({ i: s3 - 4, x: $e(t13, i3) }, { i: s3 - 2, x: $e(r3, o3) });
      } else
        (i3 || o3) && a3.push("translate(" + i3 + e2 + o3 + n2);
    }(o2.translateX, o2.translateY, a2.translateX, a2.translateY, u2, s2), function(t13, e3, n3, o3) {
      t13 !== e3 ? (t13 - e3 > 180 ? e3 += 360 : e3 - t13 > 180 && (t13 += 360), o3.push({ i: n3.push(i2(n3) + "rotate(", null, r2) - 2, x: $e(t13, e3) })) : e3 && n3.push(i2(n3) + "rotate(" + e3 + r2);
    }(o2.rotate, a2.rotate, u2, s2), function(t13, e3, n3, o3) {
      t13 !== e3 ? o3.push({ i: n3.push(i2(n3) + "skewX(", null, r2) - 2, x: $e(t13, e3) }) : e3 && n3.push(i2(n3) + "skewX(" + e3 + r2);
    }(o2.skewX, a2.skewX, u2, s2), function(t13, e3, n3, r3, o3, a3) {
      if (t13 !== n3 || e3 !== r3) {
        var u3 = o3.push(i2(o3) + "scale(", null, ",", null, ")");
        a3.push({ i: u3 - 4, x: $e(t13, n3) }, { i: u3 - 2, x: $e(e3, r3) });
      } else
        n3 === 1 && r3 === 1 || o3.push(i2(o3) + "scale(" + n3 + "," + r3 + ")");
    }(o2.scaleX, o2.scaleY, a2.scaleX, a2.scaleY, u2, s2), o2 = a2 = null, (t13) => {
      for (var e3, n3 = -1, r3 = s2.length; ++n3 < r3; )
        u2[(e3 = s2[n3]).i] = e3.x(t13);
      return u2.join("");
    };
  };
}
var Ue = He(function(t12) {
  const e2 = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(t12 + "");
  return e2.isIdentity ? Be : We(e2.a, e2.b, e2.c, e2.d, e2.e, e2.f);
}, "px, ", "px)", "deg)"), Xe = He(function(t12) {
  return t12 == null ? Be : (De || (De = document.createElementNS("http://www.w3.org/2000/svg", "g")), De.setAttribute("transform", t12), (t12 = De.transform.baseVal.consolidate()) ? We((t12 = t12.matrix).a, t12.b, t12.c, t12.d, t12.e, t12.f) : Be);
}, ", ", ")", ")");
var Qe = function(t12) {
  return (e2, n2) => {
    var r2 = t12((e2 = we(e2)).h, (n2 = we(n2)).h), i2 = Ee(e2.s, n2.s), o2 = Ee(e2.l, n2.l), a2 = Ee(e2.opacity, n2.opacity);
    return (t13) => (e2.h = r2(t13), e2.s = i2(t13), e2.l = o2(t13), e2.opacity = a2(t13), e2 + "");
  };
}(function(t12, e2) {
  var n2 = e2 - t12;
  return n2 ? Ne(t12, n2 > 180 || n2 < -180 ? n2 - 360 * Math.round(n2 / 360) : n2) : Oe(isNaN(t12) ? e2 : t12);
});
function Ye(t12) {
  return +t12;
}
var Ge = [0, 1];
function Ze(t12) {
  return t12;
}
function Ke(t12, e2) {
  return (e2 -= t12 = +t12) ? (n2) => (n2 - t12) / e2 : function(t13) {
    return () => t13;
  }(isNaN(e2) ? NaN : 0.5);
}
function Je(t12, e2, n2) {
  var r2 = t12[0], i2 = t12[1], o2 = e2[0], a2 = e2[1];
  return i2 < r2 ? (r2 = Ke(i2, r2), o2 = n2(a2, o2)) : (r2 = Ke(r2, i2), o2 = n2(o2, a2)), (t13) => o2(r2(t13));
}
function tn(t12, e2, n2) {
  var r2 = Math.min(t12.length, e2.length) - 1, i2 = new Array(r2), o2 = new Array(r2), a2 = -1;
  for (t12[r2] < t12[0] && (t12 = t12.slice().reverse(), e2 = e2.slice().reverse()); ++a2 < r2; )
    i2[a2] = Ke(t12[a2], t12[a2 + 1]), o2[a2] = n2(e2[a2], e2[a2 + 1]);
  return (e3) => {
    var n3 = Vt(t12, e3, 1, r2) - 1;
    return o2[n3](i2[n3](e3));
  };
}
function en(t12, e2) {
  return e2.domain(t12.domain()).range(t12.range()).interpolate(t12.interpolate()).clamp(t12.clamp()).unknown(t12.unknown());
}
function nn() {
  var t12, e2, n2, r2, i2, o2, a2 = Ge, u2 = Ge, s2 = Ve, l2 = Ze;
  function c2() {
    var t13, e3, n3, s3 = Math.min(a2.length, u2.length);
    return l2 !== Ze && (t13 = a2[0], e3 = a2[s3 - 1], t13 > e3 && (n3 = t13, t13 = e3, e3 = n3), l2 = (n4) => Math.max(t13, Math.min(e3, n4))), r2 = s3 > 2 ? tn : Je, i2 = o2 = null, h2;
  }
  function h2(e3) {
    return e3 == null || isNaN(e3 = +e3) ? n2 : (i2 || (i2 = r2(a2.map(t12), u2, s2)))(t12(l2(e3)));
  }
  return h2.invert = (n3) => l2(e2((o2 || (o2 = r2(u2, a2.map(t12), $e)))(n3))), h2.domain = function(t13) {
    return arguments.length ? (a2 = Array.from(t13, Ye), c2()) : a2.slice();
  }, h2.range = function(t13) {
    return arguments.length ? (u2 = Array.from(t13), c2()) : u2.slice();
  }, h2.rangeRound = (t13) => (u2 = Array.from(t13), s2 = Fe, c2()), h2.clamp = function(t13) {
    return arguments.length ? (l2 = !!t13 || Ze, c2()) : l2 !== Ze;
  }, h2.interpolate = function(t13) {
    return arguments.length ? (s2 = t13, c2()) : s2;
  }, h2.unknown = function(t13) {
    return arguments.length ? (n2 = t13, h2) : n2;
  }, (n3, r3) => (t12 = n3, e2 = r3, c2());
}
function rn() {
  return nn()(Ze, Ze);
}
function on(t12, e2, n2, r2) {
  var i2, o2 = function(t13, e3, n3) {
    var r3 = Math.abs(e3 - t13) / Math.max(0, n3), i3 = Math.pow(10, Math.floor(Math.log(r3) / Math.LN10)), o3 = r3 / i3;
    return o3 >= Ft ? i3 *= 10 : o3 >= Dt ? i3 *= 5 : o3 >= zt && (i3 *= 2), e3 < t13 ? -i3 : i3;
  }(t12, e2, n2);
  switch ((r2 = c(r2 != null ? r2 : ",f")).type) {
    case "s":
      var a2 = Math.max(Math.abs(t12), Math.abs(e2));
      return r2.precision != null || isNaN(i2 = function(t13, e3) {
        return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor(u(e3) / 3))) - u(Math.abs(t13)));
      }(o2, a2)) || (r2.precision = i2), m(r2, a2);
    case "":
    case "e":
    case "g":
    case "p":
    case "r":
      r2.precision != null || isNaN(i2 = function(t13, e3) {
        return t13 = Math.abs(t13), e3 = Math.abs(e3) - t13, Math.max(0, u(e3) - u(t13)) + 1;
      }(o2, Math.max(Math.abs(t12), Math.abs(e2)))) || (r2.precision = i2 - (r2.type === "e"));
      break;
    case "f":
    case "%":
      r2.precision != null || isNaN(i2 = function(t13) {
        return Math.max(0, -u(Math.abs(t13)));
      }(o2)) || (r2.precision = i2 - 2 * (r2.type === "%"));
  }
  return y(r2);
}
function an(t12) {
  var e2 = t12.domain;
  return t12.ticks = (t13) => {
    var n2 = e2();
    return function(t14, e3, n3) {
      var r2, i2, o2, a2, u2 = -1;
      if (n3 = +n3, (t14 = +t14) == (e3 = +e3) && n3 > 0)
        return [t14];
      if ((r2 = e3 < t14) && (i2 = t14, t14 = e3, e3 = i2), (a2 = Bt(t14, e3, n3)) === 0 || !isFinite(a2))
        return [];
      if (a2 > 0) {
        let n4 = Math.round(t14 / a2), r3 = Math.round(e3 / a2);
        for (n4 * a2 < t14 && ++n4, r3 * a2 > e3 && --r3, o2 = new Array(i2 = r3 - n4 + 1); ++u2 < i2; )
          o2[u2] = (n4 + u2) * a2;
      } else {
        a2 = -a2;
        let n4 = Math.round(t14 * a2), r3 = Math.round(e3 * a2);
        for (n4 / a2 < t14 && ++n4, r3 / a2 > e3 && --r3, o2 = new Array(i2 = r3 - n4 + 1); ++u2 < i2; )
          o2[u2] = (n4 + u2) / a2;
      }
      return r2 && o2.reverse(), o2;
    }(n2[0], n2[n2.length - 1], t13 != null ? t13 : 10);
  }, t12.tickFormat = (t13, n2) => {
    var r2 = e2();
    return on(r2[0], r2[r2.length - 1], t13 != null ? t13 : 10, n2);
  }, t12.nice = (n2) => {
    n2 == null && (n2 = 10);
    var r2, i2, o2 = e2(), a2 = 0, u2 = o2.length - 1, s2 = o2[a2], l2 = o2[u2], c2 = 10;
    for (l2 < s2 && (i2 = s2, s2 = l2, l2 = i2, i2 = a2, a2 = u2, u2 = i2); c2-- > 0; ) {
      if ((i2 = Bt(s2, l2, n2)) === r2)
        return o2[a2] = s2, o2[u2] = l2, e2(o2);
      if (i2 > 0)
        s2 = Math.floor(s2 / i2) * i2, l2 = Math.ceil(l2 / i2) * i2;
      else {
        if (!(i2 < 0))
          break;
        s2 = Math.ceil(s2 * i2) / i2, l2 = Math.floor(l2 * i2) / i2;
      }
      r2 = i2;
    }
    return t12;
  }, t12;
}
function un() {
  var t12 = rn();
  return t12.copy = () => en(t12, un()), Wt.apply(t12, arguments), an(t12);
}
function sn() {
  var t12, e2 = 0, n2 = 1, r2 = 1, i2 = [0.5], o2 = [0, 1];
  function a2(e3) {
    return e3 != null && e3 <= e3 ? o2[Vt(i2, e3, 0, r2)] : t12;
  }
  function u2() {
    var t13 = -1;
    for (i2 = new Array(r2); ++t13 < r2; )
      i2[t13] = ((t13 + 1) * n2 - (t13 - r2) * e2) / (r2 + 1);
    return a2;
  }
  return a2.domain = function(t13) {
    return arguments.length ? ([e2, n2] = t13, e2 = +e2, n2 = +n2, u2()) : [e2, n2];
  }, a2.range = function(t13) {
    return arguments.length ? (r2 = (o2 = Array.from(t13)).length - 1, u2()) : o2.slice();
  }, a2.invertExtent = (t13) => {
    var a3 = o2.indexOf(t13);
    return a3 < 0 ? [NaN, NaN] : a3 < 1 ? [e2, i2[0]] : a3 >= r2 ? [i2[r2 - 1], n2] : [i2[a3 - 1], i2[a3]];
  }, a2.unknown = function(e3) {
    return arguments.length ? (t12 = e3, a2) : a2;
  }, a2.thresholds = () => i2.slice(), a2.copy = () => sn().domain([e2, n2]).range(o2).unknown(t12), Wt.apply(an(a2), arguments);
}
var ln = typeof global == "object" && global && global.Object === Object && global, cn = typeof self == "object" && self && self.Object === Object && self, hn = ln || cn || Function("return this")(), fn = hn.Symbol, pn = Object.prototype, dn = pn.hasOwnProperty, gn = pn.toString, yn = fn ? fn.toStringTag : void 0;
var mn = Object.prototype.toString;
var vn = fn ? fn.toStringTag : void 0;
function _n(t12) {
  return t12 == null ? t12 === void 0 ? "[object Undefined]" : "[object Null]" : vn && vn in Object(t12) ? function(t13) {
    var e2 = dn.call(t13, yn), n2 = t13[yn];
    try {
      t13[yn] = void 0;
      var r2 = true;
    } catch (t14) {
    }
    var i2 = gn.call(t13);
    return r2 && (e2 ? t13[yn] = n2 : delete t13[yn]), i2;
  }(t12) : function(t13) {
    return mn.call(t13);
  }(t12);
}
function bn(t12) {
  return t12 != null && typeof t12 == "object";
}
function wn(t12) {
  return t12;
}
var xn = Object.prototype;
function Mn(t12) {
  var e2 = t12 && t12.constructor;
  return t12 === (typeof e2 == "function" && e2.prototype || xn);
}
var Sn, An, On = (Sn = Object.keys, An = Object, (t12) => Sn(An(t12))), Nn = Object.prototype.hasOwnProperty;
function kn(t12) {
  var e2 = typeof t12;
  return t12 != null && (e2 == "object" || e2 == "function");
}
function En(t12) {
  if (!kn(t12))
    return false;
  var e2 = _n(t12);
  return e2 == "[object Function]" || e2 == "[object GeneratorFunction]" || e2 == "[object AsyncFunction]" || e2 == "[object Proxy]";
}
var In, Tn = hn["__core-js_shared__"], jn = (In = /[^.]+$/.exec(Tn && Tn.keys && Tn.keys.IE_PROTO || "")) ? "Symbol(src)_1." + In : "";
var Cn = Function.prototype.toString;
function $n(t12) {
  if (t12 != null) {
    try {
      return Cn.call(t12);
    } catch (t13) {
    }
    try {
      return t12 + "";
    } catch (t13) {
    }
  }
  return "";
}
var Rn = /^\[object .+?Constructor\]$/, Pn = Function.prototype, qn = Object.prototype, Ln = Pn.toString, Vn = qn.hasOwnProperty, Fn = RegExp("^" + Ln.call(Vn).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function Dn(t12) {
  return !(!kn(t12) || function(t13) {
    return !!jn && jn in t13;
  }(t12)) && (En(t12) ? Fn : Rn).test($n(t12));
}
function zn(t12, e2) {
  var n2 = function(t13, e3) {
    return t13 == null ? void 0 : t13[e3];
  }(t12, e2);
  return Dn(n2) ? n2 : void 0;
}
var Bn = zn(hn, "DataView"), Wn = zn(hn, "Map"), Hn = zn(hn, "Promise"), Un = zn(hn, "Set"), Xn = zn(hn, "WeakMap"), Qn = $n(Bn), Yn = $n(Wn), Gn = $n(Hn), Zn = $n(Un), Kn = $n(Xn), Jn = _n;
(Bn && Jn(new Bn(new ArrayBuffer(1))) != "[object DataView]" || Wn && Jn(new Wn()) != "[object Map]" || Hn && Jn(Hn.resolve()) != "[object Promise]" || Un && Jn(new Un()) != "[object Set]" || Xn && Jn(new Xn()) != "[object WeakMap]") && (Jn = (t12) => {
  var e2 = _n(t12), n2 = e2 == "[object Object]" ? t12.constructor : void 0, r2 = n2 ? $n(n2) : "";
  if (r2)
    switch (r2) {
      case Qn:
        return "[object DataView]";
      case Yn:
        return "[object Map]";
      case Gn:
        return "[object Promise]";
      case Zn:
        return "[object Set]";
      case Kn:
        return "[object WeakMap]";
    }
  return e2;
});
var tr = Jn;
function er(t12) {
  return bn(t12) && _n(t12) == "[object Arguments]";
}
var nr = Object.prototype, rr = nr.hasOwnProperty, ir = nr.propertyIsEnumerable, or = er(function() {
  return arguments;
}()) ? er : (t12) => bn(t12) && rr.call(t12, "callee") && !ir.call(t12, "callee"), ar = Array.isArray;
function ur(t12) {
  return typeof t12 == "number" && t12 > -1 && t12 % 1 == 0 && t12 <= 9007199254740991;
}
var sr = typeof exports == "object" && exports && !exports.nodeType && exports, lr = sr && typeof module == "object" && module && !module.nodeType && module, cr = lr && lr.exports === sr ? hn.Buffer : void 0, hr = (cr ? cr.isBuffer : void 0) || function() {
  return false;
}, fr = {};
fr["[object Float32Array]"] = fr["[object Float64Array]"] = fr["[object Int8Array]"] = fr["[object Int16Array]"] = fr["[object Int32Array]"] = fr["[object Uint8Array]"] = fr["[object Uint8ClampedArray]"] = fr["[object Uint16Array]"] = fr["[object Uint32Array]"] = true, fr["[object Arguments]"] = fr["[object Array]"] = fr["[object ArrayBuffer]"] = fr["[object Boolean]"] = fr["[object DataView]"] = fr["[object Date]"] = fr["[object Error]"] = fr["[object Function]"] = fr["[object Map]"] = fr["[object Number]"] = fr["[object Object]"] = fr["[object RegExp]"] = fr["[object Set]"] = fr["[object String]"] = fr["[object WeakMap]"] = false;
var pr = typeof exports == "object" && exports && !exports.nodeType && exports, dr = pr && typeof module == "object" && module && !module.nodeType && module, gr = dr && dr.exports === pr && ln.process, yr = (() => {
  try {
    var t12 = dr && dr.require && dr.require("util").types;
    return t12 || gr && gr.binding && gr.binding("util");
  } catch (t13) {
  }
})(), mr = yr && yr.isTypedArray, vr = mr ? function(t12) {
  return (e2) => t12(e2);
}(mr) : function(t12) {
  return bn(t12) && ur(t12.length) && !!fr[_n(t12)];
}, _r = vr, br = Object.prototype.hasOwnProperty;
function wr(t12) {
  if (t12 == null)
    return true;
  if (function(t13) {
    return t13 != null && ur(t13.length) && !En(t13);
  }(t12) && (ar(t12) || typeof t12 == "string" || typeof t12.splice == "function" || hr(t12) || _r(t12) || or(t12)))
    return !t12.length;
  var e2 = tr(t12);
  if (e2 == "[object Map]" || e2 == "[object Set]")
    return !t12.size;
  if (Mn(t12))
    return !function(t13) {
      if (!Mn(t13))
        return On(t13);
      var e3 = [];
      for (var n3 in Object(t13))
        Nn.call(t13, n3) && n3 != "constructor" && e3.push(n3);
      return e3;
    }(t12).length;
  for (var n2 in t12)
    if (br.call(t12, n2))
      return false;
  return true;
}
function xr(t12) {
  var e2 = t12 == null ? 0 : t12.length;
  return e2 ? t12[e2 - 1] : void 0;
}
function Mr(t12, e2, n2) {
  var r2 = -1, i2 = t12.length;
  e2 < 0 && (e2 = -e2 > i2 ? 0 : i2 + e2), (n2 = n2 > i2 ? i2 : n2) < 0 && (n2 += i2), i2 = e2 > n2 ? 0 : n2 - e2 >>> 0, e2 >>>= 0;
  for (var o2 = Array(i2); ++r2 < i2; )
    o2[r2] = t12[r2 + e2];
  return o2;
}
var Sr = /\s/;
var Ar = /^\s+/;
function Or(t12) {
  return t12 ? t12.slice(0, function(t13) {
    for (var e2 = t13.length; e2-- && Sr.test(t13.charAt(e2)); )
      ;
    return e2;
  }(t12) + 1).replace(Ar, "") : t12;
}
var Nr = /^[-+]0x[0-9a-f]+$/i, kr = /^0b[01]+$/i, Er = /^0o[0-7]+$/i, Ir = parseInt;
function Tr(t12) {
  if (typeof t12 == "number")
    return t12;
  if (function(t13) {
    return typeof t13 == "symbol" || bn(t13) && _n(t13) == "[object Symbol]";
  }(t12))
    return NaN;
  if (kn(t12)) {
    var e2 = typeof t12.valueOf == "function" ? t12.valueOf() : t12;
    t12 = kn(e2) ? e2 + "" : e2;
  }
  if (typeof t12 != "string")
    return t12 === 0 ? t12 : +t12;
  t12 = Or(t12);
  var n2 = kr.test(t12);
  return n2 || Er.test(t12) ? Ir(t12.slice(2), n2 ? 2 : 8) : Nr.test(t12) ? NaN : +t12;
}
function jr(t12) {
  var e2 = function(t13) {
    return t13 ? 1 / 0 === (t13 = Tr(t13)) || -1 / 0 === t13 ? 17976931348623157e292 * (t13 < 0 ? -1 : 1) : t13 == t13 ? t13 : 0 : t13 === 0 ? t13 : 0;
  }(t12), n2 = e2 % 1;
  return e2 == e2 ? n2 ? e2 - n2 : e2 : 0;
}
var Cr = Math.min;
function $r(t12, e2) {
  if ((t12 = jr(t12)) < 1 || t12 > 9007199254740991)
    return [];
  var n2, r2 = 4294967295, i2 = Cr(t12, 4294967295);
  t12 -= 4294967295;
  for (var o2 = function(t13, e3) {
    for (var n3 = -1, r3 = Array(t13); ++n3 < t13; )
      r3[n3] = e3(n3);
    return r3;
  }(i2, e2 = typeof (n2 = e2) == "function" ? n2 : wn); ++r2 < t12; )
    e2(r2);
  return o2;
}
function Rr(t12, e2) {
  return function(t13) {
    return t13 && t13.length ? ((t14, e3) => {
      for (var n2, r2 = -1, i2 = t14.length; ++r2 < i2; ) {
        var o2 = e3(t14[r2]);
        o2 !== void 0 && (n2 = n2 === void 0 ? o2 : n2 + o2);
      }
      return n2;
    })(t13, wn) : 0;
  }(function(t13, e3, n2) {
    return t13 && t13.length ? Mr(t13, 0, (e3 = n2 || e3 === void 0 ? 1 : jr(e3)) < 0 ? 0 : e3) : [];
  }(t12, e2));
}
function Pr({ tickData: t12, customSegmentStops: e2, min: n2, max: r2 }) {
  if (!ar(e2) || wr(e2))
    return t12;
  if (function(t13) {
    return t13 && t13.length ? t13[0] : void 0;
  }(e2) !== n2)
    throw new Error(`First value should be equivalent to min value given. Current min value - ${n2}`);
  if (xr(e2) !== r2)
    throw new Error(`Last value should be equivalent to max value given. Current min value - ${r2}`);
  return function(t13, e3, n3) {
    var r3 = t13 == null ? 0 : t13.length;
    return r3 ? Mr(t13, (e3 = n3 || e3 === void 0 ? 1 : jr(e3)) < 0 ? 0 : e3, r3) : [];
  }(e2.map((t13, i2) => {
    if (i2 !== 0)
      return (t13 - e2[i2 - 1]) / (r2 - n2);
  }));
}
function qr({ maxSegmentLabelCount: t12, segmentCount: e2 }) {
  const n2 = parseInt(t12, 10), r2 = parseInt(e2, 10);
  return (typeof (i2 = n2) == "number" || bn(i2) && _n(i2) == "[object Number]") && n2 >= 0 && n2 <= r2 ? n2 : r2;
  var i2;
}
function Lr({ min: t12, max: e2, segments: n2 }) {
  return un().range([0, 1]).domain([t12, e2]);
}
function Vr(t12) {
  return t12 * Math.PI / 180;
}
const Fr = { Inside: "INSIDE", Outside: "OUTSIDE" }, Dr = { easeLinear: "easeLinear", easeQuadIn: "easeQuadIn", easeQuadOut: "easeQuadOut", easeQuadInOut: "easeQuadInOut", easeCubicIn: "easeCubicIn", easeCubicOut: "easeCubicOut", easeCubicInOut: "easeCubicInOut", easePolyIn: "easePolyIn", easePolyOut: "easePolyOut", easePolyInOut: "easePolyInOut", easeSinIn: "easeSinIn", easeSinOut: "easeSinOut", easeSinInOut: "easeSinInOut", easeExpIn: "easeExpIn", easeExpOut: "easeExpOut", easeExpInOut: "easeExpInOut", easeCircleIn: "easeCircleIn", easeCircleOut: "easeCircleOut", easeCircleInOut: "easeCircleInOut", easeBounceIn: "easeBounceIn", easeBounceOut: "easeBounceOut", easeBounceInOut: "easeBounceInOut", easeBackIn: "easeBackIn", easeBackOut: "easeBackOut", easeBackInOut: "easeBackInOut", easeElasticIn: "easeElasticIn", easeElasticOut: "easeElasticOut", easeElasticInOut: "easeElasticInOut", easeElastic: "easeElastic" }, zr = { value: 0, minValue: 0, maxValue: 1e3, forceRender: false, width: 300, height: 300, paddingHorizontal: 0, paddingVertical: 0, fluidWidth: false, dimensionUnit: "px", segments: 5, maxSegmentLabels: -1, customSegmentStops: [], customSegmentLabels: [], needleColor: "steelblue", startColor: "#FF471A", endColor: "#33CC33", segmentColors: [], needleTransition: Dr.easeQuadInOut, needleTransitionDuration: 500, needleHeightRatio: 0.9, ringWidth: 60, textColor: "#666", valueFormat: "", currentValueText: "${value}", currentValuePlaceholderStyle: "${value}", labelFontSize: "14px", valueTextFontSize: "16px", valueTextFontWeight: "bold", svgAriaLabel: "React d3 speedometer" }, Br = { ringInset: 20, pointerWidth: 10, pointerTailLength: 5, minAngle: -90, maxAngle: 90, labelInset: 10 }, Wr = Math.PI, Hr = 2 * Wr, Ur = Hr - 1e-6;
function Xr() {
  this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
}
function Qr() {
  return new Xr();
}
function Yr(t12) {
  return function() {
    return t12;
  };
}
Xr.prototype = Qr.prototype = { constructor: Xr, moveTo: function(t12, e2) {
  this._ += "M" + (this._x0 = this._x1 = +t12) + "," + (this._y0 = this._y1 = +e2);
}, closePath: function() {
  this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
}, lineTo: function(t12, e2) {
  this._ += "L" + (this._x1 = +t12) + "," + (this._y1 = +e2);
}, quadraticCurveTo: function(t12, e2, n2, r2) {
  this._ += "Q" + +t12 + "," + +e2 + "," + (this._x1 = +n2) + "," + (this._y1 = +r2);
}, bezierCurveTo: function(t12, e2, n2, r2, i2, o2) {
  this._ += "C" + +t12 + "," + +e2 + "," + +n2 + "," + +r2 + "," + (this._x1 = +i2) + "," + (this._y1 = +o2);
}, arcTo: function(t12, e2, n2, r2, i2) {
  t12 = +t12, e2 = +e2, n2 = +n2, r2 = +r2, i2 = +i2;
  var o2 = this._x1, a2 = this._y1, u2 = n2 - t12, s2 = r2 - e2, l2 = o2 - t12, c2 = a2 - e2, h2 = l2 * l2 + c2 * c2;
  if (i2 < 0)
    throw new Error("negative radius: " + i2);
  if (this._x1 === null)
    this._ += "M" + (this._x1 = t12) + "," + (this._y1 = e2);
  else if (h2 > 1e-6)
    if (Math.abs(c2 * u2 - s2 * l2) > 1e-6 && i2) {
      var f2 = n2 - o2, p2 = r2 - a2, d2 = u2 * u2 + s2 * s2, g2 = f2 * f2 + p2 * p2, y2 = Math.sqrt(d2), m2 = Math.sqrt(h2), v2 = i2 * Math.tan((Wr - Math.acos((d2 + h2 - g2) / (2 * y2 * m2))) / 2), _2 = v2 / m2, b2 = v2 / y2;
      Math.abs(_2 - 1) > 1e-6 && (this._ += "L" + (t12 + _2 * l2) + "," + (e2 + _2 * c2)), this._ += "A" + i2 + "," + i2 + ",0,0," + +(c2 * f2 > l2 * p2) + "," + (this._x1 = t12 + b2 * u2) + "," + (this._y1 = e2 + b2 * s2);
    } else
      this._ += "L" + (this._x1 = t12) + "," + (this._y1 = e2);
  else
    ;
}, arc: function(t12, e2, n2, r2, i2, o2) {
  t12 = +t12, e2 = +e2, o2 = !!o2;
  var a2 = (n2 = +n2) * Math.cos(r2), u2 = n2 * Math.sin(r2), s2 = t12 + a2, l2 = e2 + u2, c2 = 1 ^ o2, h2 = o2 ? r2 - i2 : i2 - r2;
  if (n2 < 0)
    throw new Error("negative radius: " + n2);
  this._x1 === null ? this._ += "M" + s2 + "," + l2 : (Math.abs(this._x1 - s2) > 1e-6 || Math.abs(this._y1 - l2) > 1e-6) && (this._ += "L" + s2 + "," + l2), n2 && (h2 < 0 && (h2 = h2 % Hr + Hr), h2 > Ur ? this._ += "A" + n2 + "," + n2 + ",0,1," + c2 + "," + (t12 - a2) + "," + (e2 - u2) + "A" + n2 + "," + n2 + ",0,1," + c2 + "," + (this._x1 = s2) + "," + (this._y1 = l2) : h2 > 1e-6 && (this._ += "A" + n2 + "," + n2 + ",0," + +(h2 >= Wr) + "," + c2 + "," + (this._x1 = t12 + n2 * Math.cos(i2)) + "," + (this._y1 = e2 + n2 * Math.sin(i2))));
}, rect: function(t12, e2, n2, r2) {
  this._ += "M" + (this._x0 = this._x1 = +t12) + "," + (this._y0 = this._y1 = +e2) + "h" + +n2 + "v" + +r2 + "h" + -n2 + "Z";
}, toString: function() {
  return this._;
} };
const Gr = Math.abs, Zr = Math.atan2, Kr = Math.cos, Jr = Math.max, ti = Math.min, ei = Math.sin, ni = Math.sqrt, ri = Math.PI, ii = ri / 2, oi = 2 * ri;
function ai(t12) {
  return t12 > 1 ? 0 : t12 < -1 ? ri : Math.acos(t12);
}
function ui(t12) {
  return t12 >= 1 ? ii : t12 <= -1 ? -ii : Math.asin(t12);
}
function si(t12) {
  return t12.innerRadius;
}
function li(t12) {
  return t12.outerRadius;
}
function ci(t12) {
  return t12.startAngle;
}
function hi(t12) {
  return t12.endAngle;
}
function fi(t12) {
  return t12 && t12.padAngle;
}
function pi(t12, e2, n2, r2, i2, o2, a2, u2) {
  var s2 = n2 - t12, l2 = r2 - e2, c2 = a2 - i2, h2 = u2 - o2, f2 = h2 * s2 - c2 * l2;
  if (!(f2 * f2 < 1e-12))
    return [t12 + (f2 = (c2 * (e2 - o2) - h2 * (t12 - i2)) / f2) * s2, e2 + f2 * l2];
}
function di(t12, e2, n2, r2, i2, o2, a2) {
  var u2 = t12 - n2, s2 = e2 - r2, l2 = (a2 ? o2 : -o2) / ni(u2 * u2 + s2 * s2), c2 = l2 * s2, h2 = -l2 * u2, f2 = t12 + c2, p2 = e2 + h2, d2 = n2 + c2, g2 = r2 + h2, y2 = (f2 + d2) / 2, m2 = (p2 + g2) / 2, v2 = d2 - f2, _2 = g2 - p2, b2 = v2 * v2 + _2 * _2, w2 = i2 - o2, x2 = f2 * g2 - d2 * p2, M2 = (_2 < 0 ? -1 : 1) * ni(Jr(0, w2 * w2 * b2 - x2 * x2)), S2 = (x2 * _2 - v2 * M2) / b2, A2 = (-x2 * v2 - _2 * M2) / b2, O2 = (x2 * _2 + v2 * M2) / b2, N2 = (-x2 * v2 + _2 * M2) / b2, k2 = S2 - y2, E2 = A2 - m2, I2 = O2 - y2, T2 = N2 - m2;
  return k2 * k2 + E2 * E2 > I2 * I2 + T2 * T2 && (S2 = O2, A2 = N2), { cx: S2, cy: A2, x01: -c2, y01: -h2, x11: S2 * (i2 / w2 - 1), y11: A2 * (i2 / w2 - 1) };
}
function gi(t12) {
  this._context = t12;
}
function yi(t12) {
  return new gi(t12);
}
function mi(t12) {
  return t12[0];
}
function vi(t12) {
  return t12[1];
}
function _i(t12, e2) {
  var n2 = Yr(true), r2 = null, i2 = yi, o2 = null;
  function a2(a3) {
    var u2, s2, l2, c2 = (a3 = function(t13) {
      return typeof t13 == "object" && "length" in t13 ? t13 : Array.from(t13);
    }(a3)).length, h2 = false;
    for (r2 == null && (o2 = i2(l2 = Qr())), u2 = 0; u2 <= c2; ++u2)
      !(u2 < c2 && n2(s2 = a3[u2], u2, a3)) === h2 && ((h2 = !h2) ? o2.lineStart() : o2.lineEnd()), h2 && o2.point(+t12(s2, u2, a3), +e2(s2, u2, a3));
    if (l2)
      return o2 = null, l2 + "" || null;
  }
  return t12 = typeof t12 == "function" ? t12 : t12 === void 0 ? mi : Yr(t12), e2 = typeof e2 == "function" ? e2 : e2 === void 0 ? vi : Yr(e2), a2.x = function(e3) {
    return arguments.length ? (t12 = typeof e3 == "function" ? e3 : Yr(+e3), a2) : t12;
  }, a2.y = function(t13) {
    return arguments.length ? (e2 = typeof t13 == "function" ? t13 : Yr(+t13), a2) : e2;
  }, a2.defined = function(t13) {
    return arguments.length ? (n2 = typeof t13 == "function" ? t13 : Yr(!!t13), a2) : n2;
  }, a2.curve = function(t13) {
    return arguments.length ? (i2 = t13, r2 != null && (o2 = i2(r2)), a2) : i2;
  }, a2.context = function(t13) {
    return arguments.length ? (t13 == null ? r2 = o2 = null : o2 = i2(r2 = t13), a2) : r2;
  }, a2;
}
function bi(t12) {
  return t12 < 0 ? -1 : 1;
}
function wi(t12, e2, n2) {
  var r2 = t12._x1 - t12._x0, i2 = e2 - t12._x1, o2 = (t12._y1 - t12._y0) / (r2 || i2 < 0 && -0), a2 = (n2 - t12._y1) / (i2 || r2 < 0 && -0), u2 = (o2 * i2 + a2 * r2) / (r2 + i2);
  return (bi(o2) + bi(a2)) * Math.min(Math.abs(o2), Math.abs(a2), 0.5 * Math.abs(u2)) || 0;
}
function xi(t12, e2) {
  var n2 = t12._x1 - t12._x0;
  return n2 ? (3 * (t12._y1 - t12._y0) / n2 - e2) / 2 : e2;
}
function Mi(t12, e2, n2) {
  var r2 = t12._x0, i2 = t12._y0, o2 = t12._x1, a2 = t12._y1, u2 = (o2 - r2) / 3;
  t12._context.bezierCurveTo(r2 + u2, i2 + u2 * e2, o2 - u2, a2 - u2 * n2, o2, a2);
}
function Si(t12) {
  this._context = t12;
}
function Ai(t12) {
  return new Si(t12);
}
gi.prototype = { areaStart: function() {
  this._line = 0;
}, areaEnd: function() {
  this._line = NaN;
}, lineStart: function() {
  this._point = 0;
}, lineEnd: function() {
  (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
}, point: function(t12, e2) {
  switch (t12 = +t12, e2 = +e2, this._point) {
    case 0:
      this._point = 1, this._line ? this._context.lineTo(t12, e2) : this._context.moveTo(t12, e2);
      break;
    case 1:
      this._point = 2;
    default:
      this._context.lineTo(t12, e2);
  }
} }, Si.prototype = { areaStart: function() {
  this._line = 0;
}, areaEnd: function() {
  this._line = NaN;
}, lineStart: function() {
  this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
}, lineEnd: function() {
  switch (this._point) {
    case 2:
      this._context.lineTo(this._x1, this._y1);
      break;
    case 3:
      Mi(this, this._t0, xi(this, this._t0));
  }
  (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
}, point: function(t12, e2) {
  var n2 = NaN;
  if (e2 = +e2, (t12 = +t12) !== this._x1 || e2 !== this._y1) {
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t12, e2) : this._context.moveTo(t12, e2);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, Mi(this, xi(this, n2 = wi(this, t12, e2)), n2);
        break;
      default:
        Mi(this, this._t0, n2 = wi(this, t12, e2));
    }
    this._x0 = this._x1, this._x1 = t12, this._y0 = this._y1, this._y1 = e2, this._t0 = n2;
  }
} }, Object.create(Si.prototype).point = function(t12, e2) {
  Si.prototype.point.call(this, e2, t12);
};
var Oi = { value: () => {
} };
function Ni() {
  for (var t12, e2 = 0, n2 = arguments.length, r2 = {}; e2 < n2; ++e2) {
    if (!(t12 = arguments[e2] + "") || t12 in r2 || /[\s.]/.test(t12))
      throw new Error("illegal type: " + t12);
    r2[t12] = [];
  }
  return new ki(r2);
}
function ki(t12) {
  this._ = t12;
}
function Ei(t12, e2) {
  return t12.trim().split(/^|\s+/).map((t13) => {
    var n2 = "", r2 = t13.indexOf(".");
    if (r2 >= 0 && (n2 = t13.slice(r2 + 1), t13 = t13.slice(0, r2)), t13 && !e2.hasOwnProperty(t13))
      throw new Error("unknown type: " + t13);
    return { type: t13, name: n2 };
  });
}
function Ii(t12, e2) {
  for (var n2, r2 = 0, i2 = t12.length; r2 < i2; ++r2)
    if ((n2 = t12[r2]).name === e2)
      return n2.value;
}
function Ti(t12, e2, n2) {
  for (var r2 = 0, i2 = t12.length; r2 < i2; ++r2)
    if (t12[r2].name === e2) {
      t12[r2] = Oi, t12 = t12.slice(0, r2).concat(t12.slice(r2 + 1));
      break;
    }
  return n2 != null && t12.push({ name: e2, value: n2 }), t12;
}
ki.prototype = Ni.prototype = { constructor: ki, on: function(t12, e2) {
  var n2, r2 = this._, i2 = Ei(t12 + "", r2), o2 = -1, a2 = i2.length;
  if (!(arguments.length < 2)) {
    if (e2 != null && typeof e2 != "function")
      throw new Error("invalid callback: " + e2);
    for (; ++o2 < a2; )
      if (n2 = (t12 = i2[o2]).type)
        r2[n2] = Ti(r2[n2], t12.name, e2);
      else if (e2 == null)
        for (n2 in r2)
          r2[n2] = Ti(r2[n2], t12.name, null);
    return this;
  }
  for (; ++o2 < a2; )
    if ((n2 = (t12 = i2[o2]).type) && (n2 = Ii(r2[n2], t12.name)))
      return n2;
}, copy: function() {
  var t12 = {}, e2 = this._;
  for (var n2 in e2)
    t12[n2] = e2[n2].slice();
  return new ki(t12);
}, call: function(t12, e2) {
  if ((n2 = arguments.length - 2) > 0)
    for (var n2, r2, i2 = new Array(n2), o2 = 0; o2 < n2; ++o2)
      i2[o2] = arguments[o2 + 2];
  if (!this._.hasOwnProperty(t12))
    throw new Error("unknown type: " + t12);
  for (o2 = 0, n2 = (r2 = this._[t12]).length; o2 < n2; ++o2)
    r2[o2].value.apply(e2, i2);
}, apply: function(t12, e2, n2) {
  if (!this._.hasOwnProperty(t12))
    throw new Error("unknown type: " + t12);
  for (var r2 = this._[t12], i2 = 0, o2 = r2.length; i2 < o2; ++i2)
    r2[i2].value.apply(e2, n2);
} };
var ji, Ci, $i = 0, Ri = 0, Pi = 0, qi = 0, Li = 0, Vi = 0, Fi = typeof performance == "object" && performance.now ? performance : Date, Di = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : (t12) => {
  setTimeout(t12, 17);
};
function zi() {
  return Li || (Di(Bi), Li = Fi.now() + Vi);
}
function Bi() {
  Li = 0;
}
function Wi() {
  this._call = this._time = this._next = null;
}
function Hi(t12, e2, n2) {
  var r2 = new Wi();
  return r2.restart(t12, e2, n2), r2;
}
function Ui() {
  Li = (qi = Fi.now()) + Vi, $i = Ri = 0;
  try {
    !function() {
      zi(), ++$i;
      for (var t12, e2 = ji; e2; )
        (t12 = Li - e2._time) >= 0 && e2._call.call(void 0, t12), e2 = e2._next;
      --$i;
    }();
  } finally {
    $i = 0, function() {
      var t12, e2, n2 = ji, r2 = 1 / 0;
      for (; n2; )
        n2._call ? (r2 > n2._time && (r2 = n2._time), t12 = n2, n2 = n2._next) : (e2 = n2._next, n2._next = null, n2 = t12 ? t12._next = e2 : ji = e2);
      Ci = t12, Qi(r2);
    }(), Li = 0;
  }
}
function Xi() {
  var t12 = Fi.now(), e2 = t12 - qi;
  e2 > 1e3 && (Vi -= e2, qi = t12);
}
function Qi(t12) {
  $i || (Ri && (Ri = clearTimeout(Ri)), t12 - Li > 24 ? (t12 < 1 / 0 && (Ri = setTimeout(Ui, t12 - Fi.now() - Vi)), Pi && (Pi = clearInterval(Pi))) : (Pi || (qi = Fi.now(), Pi = setInterval(Xi, 1e3)), $i = 1, Di(Ui)));
}
function Yi(t12, e2, n2) {
  var r2 = new Wi();
  return e2 = e2 == null ? 0 : +e2, r2.restart((n3) => {
    r2.stop(), t12(n3 + e2);
  }, e2, n2), r2;
}
Wi.prototype = Hi.prototype = { constructor: Wi, restart: function(t12, e2, n2) {
  if (typeof t12 != "function")
    throw new TypeError("callback is not a function");
  n2 = (n2 == null ? zi() : +n2) + (e2 == null ? 0 : +e2), this._next || Ci === this || (Ci ? Ci._next = this : ji = this, Ci = this), this._call = t12, this._time = n2, Qi();
}, stop: function() {
  this._call && (this._call = null, this._time = 1 / 0, Qi());
} };
var Gi = Ni("start", "end", "cancel", "interrupt"), Zi = [];
function Ki(t12, e2, n2, r2, i2, o2) {
  var a2 = t12.__transition;
  if (a2) {
    if (n2 in a2)
      return;
  } else
    t12.__transition = {};
  !function(t13, e3, n3) {
    var r3, i3 = t13.__transition;
    function o3(t14) {
      n3.state = 1, n3.timer.restart(a3, n3.delay, n3.time), n3.delay <= t14 && a3(t14 - n3.delay);
    }
    function a3(o4) {
      var l2, c2, h2, f2;
      if (n3.state !== 1)
        return s2();
      for (l2 in i3)
        if ((f2 = i3[l2]).name === n3.name) {
          if (f2.state === 3)
            return Yi(a3);
          f2.state === 4 ? (f2.state = 6, f2.timer.stop(), f2.on.call("interrupt", t13, t13.__data__, f2.index, f2.group), delete i3[l2]) : +l2 < e3 && (f2.state = 6, f2.timer.stop(), f2.on.call("cancel", t13, t13.__data__, f2.index, f2.group), delete i3[l2]);
        }
      if (Yi(() => {
        n3.state === 3 && (n3.state = 4, n3.timer.restart(u2, n3.delay, n3.time), u2(o4));
      }), n3.state = 2, n3.on.call("start", t13, t13.__data__, n3.index, n3.group), n3.state === 2) {
        for (n3.state = 3, r3 = new Array(h2 = n3.tween.length), l2 = 0, c2 = -1; l2 < h2; ++l2)
          (f2 = n3.tween[l2].value.call(t13, t13.__data__, n3.index, n3.group)) && (r3[++c2] = f2);
        r3.length = c2 + 1;
      }
    }
    function u2(e4) {
      for (var i4 = e4 < n3.duration ? n3.ease.call(null, e4 / n3.duration) : (n3.timer.restart(s2), n3.state = 5, 1), o4 = -1, a4 = r3.length; ++o4 < a4; )
        r3[o4].call(t13, i4);
      n3.state === 5 && (n3.on.call("end", t13, t13.__data__, n3.index, n3.group), s2());
    }
    function s2() {
      for (var r4 in n3.state = 6, n3.timer.stop(), delete i3[e3], i3)
        return;
      delete t13.__transition;
    }
    i3[e3] = n3, n3.timer = Hi(o3, 0, n3.time);
  }(t12, n2, { name: e2, index: r2, group: i2, on: Gi, tween: Zi, time: o2.time, delay: o2.delay, duration: o2.duration, ease: o2.ease, timer: null, state: 0 });
}
function Ji(t12, e2) {
  var n2 = eo(t12, e2);
  if (n2.state > 0)
    throw new Error("too late; already scheduled");
  return n2;
}
function to(t12, e2) {
  var n2 = eo(t12, e2);
  if (n2.state > 3)
    throw new Error("too late; already running");
  return n2;
}
function eo(t12, e2) {
  var n2 = t12.__transition;
  if (!n2 || !(n2 = n2[e2]))
    throw new Error("transition not found");
  return n2;
}
function no(t12, e2) {
  var n2, r2;
  return function() {
    var i2 = to(this, t12), o2 = i2.tween;
    if (o2 !== n2) {
      for (var a2 = 0, u2 = (r2 = n2 = o2).length; a2 < u2; ++a2)
        if (r2[a2].name === e2) {
          (r2 = r2.slice()).splice(a2, 1);
          break;
        }
    }
    i2.tween = r2;
  };
}
function ro(t12, e2, n2) {
  var r2, i2;
  if (typeof n2 != "function")
    throw new Error();
  return function() {
    var o2 = to(this, t12), a2 = o2.tween;
    if (a2 !== r2) {
      i2 = (r2 = a2).slice();
      for (var u2 = { name: e2, value: n2 }, s2 = 0, l2 = i2.length; s2 < l2; ++s2)
        if (i2[s2].name === e2) {
          i2[s2] = u2;
          break;
        }
      s2 === l2 && i2.push(u2);
    }
    o2.tween = i2;
  };
}
function io(t12, e2, n2) {
  var r2 = t12._id;
  return t12.each(function() {
    var t13 = to(this, r2);
    (t13.value || (t13.value = {}))[e2] = n2.apply(this, arguments);
  }), (t13) => eo(t13, r2).value[e2];
}
function oo(t12, e2) {
  var n2;
  return (typeof e2 == "number" ? $e : e2 instanceof se ? Ie : (n2 = se(e2)) ? (e2 = n2, Ie) : Le)(t12, e2);
}
function ao(t12) {
  return function() {
    this.removeAttribute(t12);
  };
}
function uo(t12) {
  return function() {
    this.removeAttributeNS(t12.space, t12.local);
  };
}
function so(t12, e2, n2) {
  var r2, i2, o2 = n2 + "";
  return function() {
    var a2 = this.getAttribute(t12);
    return a2 === o2 ? null : a2 === r2 ? i2 : i2 = e2(r2 = a2, n2);
  };
}
function lo(t12, e2, n2) {
  var r2, i2, o2 = n2 + "";
  return function() {
    var a2 = this.getAttributeNS(t12.space, t12.local);
    return a2 === o2 ? null : a2 === r2 ? i2 : i2 = e2(r2 = a2, n2);
  };
}
function co(t12, e2, n2) {
  var r2, i2, o2;
  return function() {
    var a2, u2, s2 = n2(this);
    if (s2 != null)
      return (a2 = this.getAttribute(t12)) === (u2 = s2 + "") ? null : a2 === r2 && u2 === i2 ? o2 : (i2 = u2, o2 = e2(r2 = a2, s2));
    this.removeAttribute(t12);
  };
}
function ho(t12, e2, n2) {
  var r2, i2, o2;
  return function() {
    var a2, u2, s2 = n2(this);
    if (s2 != null)
      return (a2 = this.getAttributeNS(t12.space, t12.local)) === (u2 = s2 + "") ? null : a2 === r2 && u2 === i2 ? o2 : (i2 = u2, o2 = e2(r2 = a2, s2));
    this.removeAttributeNS(t12.space, t12.local);
  };
}
function fo(t12, e2) {
  return function(n2) {
    this.setAttribute(t12, e2.call(this, n2));
  };
}
function po(t12, e2) {
  return function(n2) {
    this.setAttributeNS(t12.space, t12.local, e2.call(this, n2));
  };
}
function go(t12, e2) {
  var n2, r2;
  function i2() {
    var i3 = e2.apply(this, arguments);
    return i3 !== r2 && (n2 = (r2 = i3) && po(t12, i3)), n2;
  }
  return i2._value = e2, i2;
}
function yo(t12, e2) {
  var n2, r2;
  function i2() {
    var i3 = e2.apply(this, arguments);
    return i3 !== r2 && (n2 = (r2 = i3) && fo(t12, i3)), n2;
  }
  return i2._value = e2, i2;
}
function mo(t12, e2) {
  return function() {
    Ji(this, t12).delay = +e2.apply(this, arguments);
  };
}
function vo(t12, e2) {
  return e2 = +e2, function() {
    Ji(this, t12).delay = e2;
  };
}
function _o(t12, e2) {
  return function() {
    to(this, t12).duration = +e2.apply(this, arguments);
  };
}
function bo(t12, e2) {
  return e2 = +e2, function() {
    to(this, t12).duration = e2;
  };
}
function wo(t12, e2) {
  if (typeof e2 != "function")
    throw new Error();
  return function() {
    to(this, t12).ease = e2;
  };
}
function xo(t12, e2, n2) {
  var r2, i2, o2 = function(t13) {
    return (t13 + "").trim().split(/^|\s+/).every((t14) => {
      var e3 = t14.indexOf(".");
      return e3 >= 0 && (t14 = t14.slice(0, e3)), !t14 || t14 === "start";
    });
  }(e2) ? Ji : to;
  return function() {
    var a2 = o2(this, t12), u2 = a2.on;
    u2 !== r2 && (i2 = (r2 = u2).copy()).on(e2, n2), a2.on = i2;
  };
}
var Mo = $t.prototype.constructor;
function So(t12) {
  return function() {
    this.style.removeProperty(t12);
  };
}
function Ao(t12, e2, n2) {
  return function(r2) {
    this.style.setProperty(t12, e2.call(this, r2), n2);
  };
}
function Oo(t12, e2, n2) {
  var r2, i2;
  function o2() {
    var o3 = e2.apply(this, arguments);
    return o3 !== i2 && (r2 = (i2 = o3) && Ao(t12, o3, n2)), r2;
  }
  return o2._value = e2, o2;
}
function No(t12) {
  return function(e2) {
    this.textContent = t12.call(this, e2);
  };
}
function ko(t12) {
  var e2, n2;
  function r2() {
    var r3 = t12.apply(this, arguments);
    return r3 !== n2 && (e2 = (n2 = r3) && No(r3)), e2;
  }
  return r2._value = t12, r2;
}
var Eo = 0;
function Io(t12, e2, n2, r2) {
  this._groups = t12, this._parents = e2, this._name = n2, this._id = r2;
}
function To(t12) {
  return $t().transition(t12);
}
function jo() {
  return ++Eo;
}
var Co = $t.prototype;
Io.prototype = To.prototype = { constructor: Io, select: function(t12) {
  var e2 = this._name, n2 = this._id;
  typeof t12 != "function" && (t12 = k(t12));
  for (var r2 = this._groups, i2 = r2.length, o2 = new Array(i2), a2 = 0; a2 < i2; ++a2)
    for (var u2, s2, l2 = r2[a2], c2 = l2.length, h2 = o2[a2] = new Array(c2), f2 = 0; f2 < c2; ++f2)
      (u2 = l2[f2]) && (s2 = t12.call(u2, u2.__data__, f2, l2)) && ("__data__" in u2 && (s2.__data__ = u2.__data__), h2[f2] = s2, Ki(h2[f2], e2, n2, f2, h2, eo(u2, n2)));
  return new Io(o2, this._parents, e2, n2);
}, selectAll: function(t12) {
  var e2 = this._name, n2 = this._id;
  typeof t12 != "function" && (t12 = T(t12));
  for (var r2 = this._groups, i2 = r2.length, o2 = [], a2 = [], u2 = 0; u2 < i2; ++u2)
    for (var s2, l2 = r2[u2], c2 = l2.length, h2 = 0; h2 < c2; ++h2)
      if (s2 = l2[h2]) {
        for (var f2, p2 = t12.call(s2, s2.__data__, h2, l2), d2 = eo(s2, n2), g2 = 0, y2 = p2.length; g2 < y2; ++g2)
          (f2 = p2[g2]) && Ki(f2, e2, n2, g2, p2, d2);
        o2.push(p2), a2.push(s2);
      }
  return new Io(o2, a2, e2, n2);
}, selectChild: Co.selectChild, selectChildren: Co.selectChildren, filter: function(t12) {
  typeof t12 != "function" && (t12 = j(t12));
  for (var e2 = this._groups, n2 = e2.length, r2 = new Array(n2), i2 = 0; i2 < n2; ++i2)
    for (var o2, a2 = e2[i2], u2 = a2.length, s2 = r2[i2] = [], l2 = 0; l2 < u2; ++l2)
      (o2 = a2[l2]) && t12.call(o2, o2.__data__, l2, a2) && s2.push(o2);
  return new Io(r2, this._parents, this._name, this._id);
}, merge: function(t12) {
  if (t12._id !== this._id)
    throw new Error();
  for (var e2 = this._groups, n2 = t12._groups, r2 = e2.length, i2 = n2.length, o2 = Math.min(r2, i2), a2 = new Array(r2), u2 = 0; u2 < o2; ++u2)
    for (var s2, l2 = e2[u2], c2 = n2[u2], h2 = l2.length, f2 = a2[u2] = new Array(h2), p2 = 0; p2 < h2; ++p2)
      (s2 = l2[p2] || c2[p2]) && (f2[p2] = s2);
  for (; u2 < r2; ++u2)
    a2[u2] = e2[u2];
  return new Io(a2, this._parents, this._name, this._id);
}, selection: function() {
  return new Mo(this._groups, this._parents);
}, transition: function() {
  for (var t12 = this._name, e2 = this._id, n2 = jo(), r2 = this._groups, i2 = r2.length, o2 = 0; o2 < i2; ++o2)
    for (var a2, u2 = r2[o2], s2 = u2.length, l2 = 0; l2 < s2; ++l2)
      if (a2 = u2[l2]) {
        var c2 = eo(a2, e2);
        Ki(a2, t12, n2, l2, u2, { time: c2.time + c2.delay + c2.duration, delay: 0, duration: c2.duration, ease: c2.ease });
      }
  return new Io(r2, this._parents, t12, n2);
}, call: Co.call, nodes: Co.nodes, node: Co.node, size: Co.size, empty: Co.empty, each: Co.each, on: function(t12, e2) {
  var n2 = this._id;
  return arguments.length < 2 ? eo(this.node(), n2).on.on(t12) : this.each(xo(n2, t12, e2));
}, attr: function(t12, e2) {
  var n2 = M(t12), r2 = n2 === "transform" ? Xe : oo;
  return this.attrTween(t12, typeof e2 == "function" ? (n2.local ? ho : co)(n2, r2, io(this, "attr." + t12, e2)) : e2 == null ? (n2.local ? uo : ao)(n2) : (n2.local ? lo : so)(n2, r2, e2));
}, attrTween: function(t12, e2) {
  var n2 = "attr." + t12;
  if (arguments.length < 2)
    return (n2 = this.tween(n2)) && n2._value;
  if (e2 == null)
    return this.tween(n2, null);
  if (typeof e2 != "function")
    throw new Error();
  var r2 = M(t12);
  return this.tween(n2, (r2.local ? go : yo)(r2, e2));
}, style: function(t12, e2, n2) {
  var r2 = (t12 += "") == "transform" ? Ue : oo;
  return e2 == null ? this.styleTween(t12, function(t13, e3) {
    var n3, r3, i2;
    return function() {
      var o2 = nt(this, t13), a2 = (this.style.removeProperty(t13), nt(this, t13));
      return o2 === a2 ? null : o2 === n3 && a2 === r3 ? i2 : i2 = e3(n3 = o2, r3 = a2);
    };
  }(t12, r2)).on("end.style." + t12, So(t12)) : typeof e2 == "function" ? this.styleTween(t12, function(t13, e3, n3) {
    var r3, i2, o2;
    return function() {
      var a2 = nt(this, t13), u2 = n3(this), s2 = u2 + "";
      return u2 == null && (this.style.removeProperty(t13), s2 = u2 = nt(this, t13)), a2 === s2 ? null : a2 === r3 && s2 === i2 ? o2 : (i2 = s2, o2 = e3(r3 = a2, u2));
    };
  }(t12, r2, io(this, "style." + t12, e2))).each(function(t13, e3) {
    var n3, r3, i2, o2, a2 = "style." + e3, u2 = "end." + a2;
    return function() {
      var s2 = to(this, t13), l2 = s2.on, c2 = s2.value[a2] == null ? o2 || (o2 = So(e3)) : void 0;
      l2 === n3 && i2 === c2 || (r3 = (n3 = l2).copy()).on(u2, i2 = c2), s2.on = r3;
    };
  }(this._id, t12)) : this.styleTween(t12, function(t13, e3, n3) {
    var r3, i2, o2 = n3 + "";
    return function() {
      var a2 = nt(this, t13);
      return a2 === o2 ? null : a2 === r3 ? i2 : i2 = e3(r3 = a2, n3);
    };
  }(t12, r2, e2), n2).on("end.style." + t12, null);
}, styleTween: function(t12, e2, n2) {
  var r2 = "style." + (t12 += "");
  if (arguments.length < 2)
    return (r2 = this.tween(r2)) && r2._value;
  if (e2 == null)
    return this.tween(r2, null);
  if (typeof e2 != "function")
    throw new Error();
  return this.tween(r2, Oo(t12, e2, n2 != null ? n2 : ""));
}, text: function(t12) {
  return this.tween("text", typeof t12 == "function" ? function(t13) {
    return function() {
      var e2 = t13(this);
      this.textContent = e2 != null ? e2 : "";
    };
  }(io(this, "text", t12)) : function(t13) {
    return function() {
      this.textContent = t13;
    };
  }(t12 == null ? "" : t12 + ""));
}, textTween: function(t12) {
  var e2 = "text";
  if (arguments.length < 1)
    return (e2 = this.tween(e2)) && e2._value;
  if (t12 == null)
    return this.tween(e2, null);
  if (typeof t12 != "function")
    throw new Error();
  return this.tween(e2, ko(t12));
}, remove: function() {
  return this.on("end.remove", function(t12) {
    return function() {
      var e2 = this.parentNode;
      for (var n2 in this.__transition)
        if (+n2 !== t12)
          return;
      e2 && e2.removeChild(this);
    };
  }(this._id));
}, tween: function(t12, e2) {
  var n2 = this._id;
  if (t12 += "", arguments.length < 2) {
    for (var r2, i2 = eo(this.node(), n2).tween, o2 = 0, a2 = i2.length; o2 < a2; ++o2)
      if ((r2 = i2[o2]).name === t12)
        return r2.value;
    return null;
  }
  return this.each((e2 == null ? no : ro)(n2, t12, e2));
}, delay: function(t12) {
  var e2 = this._id;
  return arguments.length ? this.each((typeof t12 == "function" ? mo : vo)(e2, t12)) : eo(this.node(), e2).delay;
}, duration: function(t12) {
  var e2 = this._id;
  return arguments.length ? this.each((typeof t12 == "function" ? _o : bo)(e2, t12)) : eo(this.node(), e2).duration;
}, ease: function(t12) {
  var e2 = this._id;
  return arguments.length ? this.each(wo(e2, t12)) : eo(this.node(), e2).ease;
}, easeVarying: function(t12) {
  if (typeof t12 != "function")
    throw new Error();
  return this.each(function(t13, e2) {
    return function() {
      var n2 = e2.apply(this, arguments);
      if (typeof n2 != "function")
        throw new Error();
      to(this, t13).ease = n2;
    };
  }(this._id, t12));
}, end: function() {
  var t12, e2, n2 = this, r2 = n2._id, i2 = n2.size();
  return new Promise(function(o2, a2) {
    var u2 = { value: a2 }, s2 = { value: () => {
      --i2 == 0 && o2();
    } };
    n2.each(function() {
      var n3 = to(this, r2), i3 = n3.on;
      i3 !== t12 && ((e2 = (t12 = i3).copy())._.cancel.push(u2), e2._.interrupt.push(u2), e2._.end.push(s2)), n3.on = e2;
    }), i2 === 0 && o2();
  });
}, [Symbol.iterator]: Co[Symbol.iterator] };
const $o = (t12) => +t12;
function Ro(t12) {
  return t12 * t12;
}
function Po(t12) {
  return t12 * (2 - t12);
}
function qo(t12) {
  return ((t12 *= 2) <= 1 ? t12 * t12 : --t12 * (2 - t12) + 1) / 2;
}
function Lo(t12) {
  return t12 * t12 * t12;
}
function Vo(t12) {
  return --t12 * t12 * t12 + 1;
}
function Fo(t12) {
  return ((t12 *= 2) <= 1 ? t12 * t12 * t12 : (t12 -= 2) * t12 * t12 + 2) / 2;
}
var Do = function t3(e2) {
  function n2(t12) {
    return Math.pow(t12, e2);
  }
  return e2 = +e2, n2.exponent = t3, n2;
}(3), zo = function t4(e2) {
  function n2(t12) {
    return 1 - Math.pow(1 - t12, e2);
  }
  return e2 = +e2, n2.exponent = t4, n2;
}(3), Bo = function t5(e2) {
  function n2(t12) {
    return ((t12 *= 2) <= 1 ? Math.pow(t12, e2) : 2 - Math.pow(2 - t12, e2)) / 2;
  }
  return e2 = +e2, n2.exponent = t5, n2;
}(3), Wo = Math.PI, Ho = Wo / 2;
function Uo(t12) {
  return +t12 == 1 ? 1 : 1 - Math.cos(t12 * Ho);
}
function Xo(t12) {
  return Math.sin(t12 * Ho);
}
function Qo(t12) {
  return (1 - Math.cos(Wo * t12)) / 2;
}
function Yo(t12) {
  return 1.0009775171065494 * (Math.pow(2, -10 * t12) - 9765625e-10);
}
function Go(t12) {
  return Yo(1 - +t12);
}
function Zo(t12) {
  return 1 - Yo(t12);
}
function Ko(t12) {
  return ((t12 *= 2) <= 1 ? Yo(1 - t12) : 2 - Yo(t12 - 1)) / 2;
}
function Jo(t12) {
  return 1 - Math.sqrt(1 - t12 * t12);
}
function ta(t12) {
  return Math.sqrt(1 - --t12 * t12);
}
function ea(t12) {
  return ((t12 *= 2) <= 1 ? 1 - Math.sqrt(1 - t12 * t12) : Math.sqrt(1 - (t12 -= 2) * t12) + 1) / 2;
}
var na = 4 / 11, ra = 7.5625;
function ia(t12) {
  return 1 - oa(1 - t12);
}
function oa(t12) {
  return (t12 = +t12) < na ? ra * t12 * t12 : t12 < 0.7272727272727273 ? ra * (t12 -= 0.5454545454545454) * t12 + 0.75 : t12 < 0.9090909090909091 ? ra * (t12 -= 0.8181818181818182) * t12 + 0.9375 : ra * (t12 -= 0.9545454545454546) * t12 + 0.984375;
}
function aa(t12) {
  return ((t12 *= 2) <= 1 ? 1 - oa(1 - t12) : oa(t12 - 1) + 1) / 2;
}
var ua = function t6(e2) {
  function n2(t12) {
    return (t12 = +t12) * t12 * (e2 * (t12 - 1) + t12);
  }
  return e2 = +e2, n2.overshoot = t6, n2;
}(1.70158), sa = function t7(e2) {
  function n2(t12) {
    return --t12 * t12 * ((t12 + 1) * e2 + t12) + 1;
  }
  return e2 = +e2, n2.overshoot = t7, n2;
}(1.70158), la = function t8(e2) {
  function n2(t12) {
    return ((t12 *= 2) < 1 ? t12 * t12 * ((e2 + 1) * t12 - e2) : (t12 -= 2) * t12 * ((e2 + 1) * t12 + e2) + 2) / 2;
  }
  return e2 = +e2, n2.overshoot = t8, n2;
}(1.70158), ca = 2 * Math.PI, ha = function t9(e2, n2) {
  var r2 = Math.asin(1 / (e2 = Math.max(1, e2))) * (n2 /= ca);
  function i2(t12) {
    return e2 * Yo(- --t12) * Math.sin((r2 - t12) / n2);
  }
  return i2.amplitude = (e3) => t9(e3, n2 * ca), i2.period = (n3) => t9(e2, n3), i2;
}(1, 0.3), fa = function t10(e2, n2) {
  var r2 = Math.asin(1 / (e2 = Math.max(1, e2))) * (n2 /= ca);
  function i2(t12) {
    return 1 - e2 * Yo(t12 = +t12) * Math.sin((t12 + r2) / n2);
  }
  return i2.amplitude = (e3) => t10(e3, n2 * ca), i2.period = (n3) => t10(e2, n3), i2;
}(1, 0.3), pa = function t11(e2, n2) {
  var r2 = Math.asin(1 / (e2 = Math.max(1, e2))) * (n2 /= ca);
  function i2(t12) {
    return ((t12 = 2 * t12 - 1) < 0 ? e2 * Yo(-t12) * Math.sin((r2 - t12) / n2) : 2 - e2 * Yo(t12) * Math.sin((r2 + t12) / n2)) / 2;
  }
  return i2.amplitude = (e3) => t11(e3, n2 * ca), i2.period = (n3) => t11(e2, n3), i2;
}(1, 0.3), da = { time: null, delay: 0, duration: 250, ease: Fo };
function ga(t12, e2) {
  for (var n2; !(n2 = t12.__transition) || !(n2 = n2[e2]); )
    if (!(t12 = t12.parentNode))
      throw new Error(`transition ${e2} not found`);
  return n2;
}
function ya(t12) {
  switch (t12) {
    case Dr.easeLinear:
      return $o;
    case Dr.easeQuadIn:
      return Ro;
    case Dr.easeQuadOut:
      return Po;
    case Dr.easeQuadInOut:
      return qo;
    case Dr.easeCubicIn:
      return Lo;
    case Dr.easeCubicOut:
      return Vo;
    case Dr.easeCubicInOut:
      return Fo;
    case Dr.easePolyIn:
      return Do;
    case Dr.easePolyOut:
      return zo;
    case Dr.easePolyInOut:
      return Bo;
    case Dr.easeSinIn:
      return Uo;
    case Dr.easeSinOut:
      return Xo;
    case Dr.easeSinInOut:
      return Qo;
    case Dr.easeExpIn:
      return Go;
    case Dr.easeExpOut:
      return Zo;
    case Dr.easeExpInOut:
      return Ko;
    case Dr.easeCircleIn:
      return Jo;
    case Dr.easeCircleOut:
      return ta;
    case Dr.easeCircleInOut:
      return ea;
    case Dr.easeBounceIn:
      return ia;
    case Dr.easeBounceOut:
      return oa;
    case Dr.easeBounceInOut:
      return aa;
    case Dr.easeBackIn:
      return ua;
    case Dr.easeBackOut:
      return sa;
    case Dr.easeBackInOut:
      return la;
    case Dr.easeElasticIn:
      return ha;
    case Dr.easeElasticOut:
      return fa;
    case Dr.easeElasticInOut:
      return pa;
    case Dr.easeElastic:
      return fa;
    default:
      return qo;
  }
}
$t.prototype.interrupt = function(t12) {
  return this.each(function() {
    !function(t13, e2) {
      var n2, r2, i2, o2 = t13.__transition, a2 = true;
      if (o2) {
        for (i2 in e2 = e2 == null ? null : e2 + "", o2)
          (n2 = o2[i2]).name === e2 ? (r2 = n2.state > 2 && n2.state < 5, n2.state = 6, n2.timer.stop(), n2.on.call(r2 ? "interrupt" : "cancel", t13, t13.__data__, n2.index, n2.group), delete o2[i2]) : a2 = false;
        a2 && delete t13.__transition;
      }
    }(this, t12);
  });
}, $t.prototype.transition = function(t12) {
  var e2, n2;
  t12 instanceof Io ? (e2 = t12._id, t12 = t12._name) : (e2 = jo(), (n2 = da).time = zi(), t12 = t12 == null ? null : t12 + "");
  for (var r2 = this._groups, i2 = r2.length, o2 = 0; o2 < i2; ++o2)
    for (var a2, u2 = r2[o2], s2 = u2.length, l2 = 0; l2 < s2; ++l2)
      (a2 = u2[l2]) && Ki(a2, t12, e2, l2, u2, n2 || ga(a2, e2));
  return new Io(r2, this._parents, t12, e2);
};
var ma = Number.isNaN || function(t12) {
  return typeof t12 == "number" && t12 != t12;
};
function va(t12, e2) {
  if (t12.length !== e2.length)
    return false;
  for (var n2 = 0; n2 < t12.length; n2++)
    if (r2 = t12[n2], i2 = e2[n2], !(r2 === i2 || ma(r2) && ma(i2)))
      return false;
  var r2, i2;
  return true;
}
function _a(t12, e2) {
  e2 === void 0 && (e2 = va);
  var n2 = null;
  function r2() {
    for (var r3 = [], i2 = 0; i2 < arguments.length; i2++)
      r3[i2] = arguments[i2];
    if (n2 && n2.lastThis === this && e2(r3, n2.lastArgs))
      return n2.lastResult;
    var o2 = t12.apply(this, r3);
    return n2 = { lastResult: o2, lastArgs: r3, lastThis: this }, o2;
  }
  return r2.clear = function() {
    n2 = null;
  }, r2;
}
const ba = _a(function(t12) {
  return Lr({ min: t12.minValue, max: t12.maxValue, segments: t12.maxSegmentLabels });
}), wa = _a(function(t12) {
  let e2 = function(t13, { min: e3, max: n2, segments: r2 }) {
    let i2 = [];
    if (i2 = t13.ticks(r2), (xr(i2) !== n2 || r2 < i2.length) && i2.length > 1) {
      const t14 = (n2 - e3) / r2;
      i2 = [e3], $r(r2, (n3) => {
        i2.push(e3 + (n3 + 1) * t14);
      });
    }
    return i2.length === 1 && (i2 = [e3, n2]), i2;
  }(ba(t12), { min: t12.minValue, max: t12.maxValue, segments: t12.maxSegmentLabels });
  t12.customSegmentStops.length > 0 && t12.maxSegmentLabels !== 0 && (e2 = t12.customSegmentStops);
  return e2;
}), xa = _a(function(t12) {
  const e2 = function(t13, e3, n2) {
    t13 = +t13, e3 = +e3, n2 = (i2 = arguments.length) < 2 ? (e3 = t13, t13 = 0, 1) : i2 < 3 ? 1 : +n2;
    for (var r2 = -1, i2 = 0 | Math.max(0, Math.ceil((e3 - t13) / n2)), o2 = new Array(i2); ++r2 < i2; )
      o2[r2] = t13 + r2 * n2;
    return o2;
  }(t12.majorTicks).map((e3) => 1 / t12.majorTicks);
  return Pr({ tickData: e2, customSegmentStops: t12.customSegmentStops, min: t12.minValue, max: t12.maxValue });
}), Ma = _a(function(t12) {
  const e2 = xa(t12), n2 = t12.maxAngle - t12.minAngle, r2 = t12.width / 2;
  return function() {
    var t13 = si, e3 = li, n3 = Yr(0), r3 = null, i2 = ci, o2 = hi, a2 = fi, u2 = null;
    function s2() {
      var s3, l2, c2 = +t13.apply(this, arguments), h2 = +e3.apply(this, arguments), f2 = i2.apply(this, arguments) - ii, p2 = o2.apply(this, arguments) - ii, d2 = Gr(p2 - f2), g2 = p2 > f2;
      if (u2 || (u2 = s3 = Qr()), h2 < c2 && (l2 = h2, h2 = c2, c2 = l2), h2 > 1e-12)
        if (d2 > oi - 1e-12)
          u2.moveTo(h2 * Kr(f2), h2 * ei(f2)), u2.arc(0, 0, h2, f2, p2, !g2), c2 > 1e-12 && (u2.moveTo(c2 * Kr(p2), c2 * ei(p2)), u2.arc(0, 0, c2, p2, f2, g2));
        else {
          var y2, m2, v2 = f2, _2 = p2, b2 = f2, w2 = p2, x2 = d2, M2 = d2, S2 = a2.apply(this, arguments) / 2, A2 = S2 > 1e-12 && (r3 ? +r3.apply(this, arguments) : ni(c2 * c2 + h2 * h2)), O2 = ti(Gr(h2 - c2) / 2, +n3.apply(this, arguments)), N2 = O2, k2 = O2;
          if (A2 > 1e-12) {
            var E2 = ui(A2 / c2 * ei(S2)), I2 = ui(A2 / h2 * ei(S2));
            (x2 -= 2 * E2) > 1e-12 ? (b2 += E2 *= g2 ? 1 : -1, w2 -= E2) : (x2 = 0, b2 = w2 = (f2 + p2) / 2), (M2 -= 2 * I2) > 1e-12 ? (v2 += I2 *= g2 ? 1 : -1, _2 -= I2) : (M2 = 0, v2 = _2 = (f2 + p2) / 2);
          }
          var T2 = h2 * Kr(v2), j2 = h2 * ei(v2), C2 = c2 * Kr(w2), $2 = c2 * ei(w2);
          if (O2 > 1e-12) {
            var R2, P2 = h2 * Kr(_2), q2 = h2 * ei(_2), L2 = c2 * Kr(b2), V2 = c2 * ei(b2);
            if (d2 < ri && (R2 = pi(T2, j2, L2, V2, P2, q2, C2, $2))) {
              var F2 = T2 - R2[0], D2 = j2 - R2[1], z2 = P2 - R2[0], B2 = q2 - R2[1], W2 = 1 / ei(ai((F2 * z2 + D2 * B2) / (ni(F2 * F2 + D2 * D2) * ni(z2 * z2 + B2 * B2))) / 2), H2 = ni(R2[0] * R2[0] + R2[1] * R2[1]);
              N2 = ti(O2, (c2 - H2) / (W2 - 1)), k2 = ti(O2, (h2 - H2) / (W2 + 1));
            }
          }
          M2 > 1e-12 ? k2 > 1e-12 ? (y2 = di(L2, V2, T2, j2, h2, k2, g2), m2 = di(P2, q2, C2, $2, h2, k2, g2), u2.moveTo(y2.cx + y2.x01, y2.cy + y2.y01), k2 < O2 ? u2.arc(y2.cx, y2.cy, k2, Zr(y2.y01, y2.x01), Zr(m2.y01, m2.x01), !g2) : (u2.arc(y2.cx, y2.cy, k2, Zr(y2.y01, y2.x01), Zr(y2.y11, y2.x11), !g2), u2.arc(0, 0, h2, Zr(y2.cy + y2.y11, y2.cx + y2.x11), Zr(m2.cy + m2.y11, m2.cx + m2.x11), !g2), u2.arc(m2.cx, m2.cy, k2, Zr(m2.y11, m2.x11), Zr(m2.y01, m2.x01), !g2))) : (u2.moveTo(T2, j2), u2.arc(0, 0, h2, v2, _2, !g2)) : u2.moveTo(T2, j2), c2 > 1e-12 && x2 > 1e-12 ? N2 > 1e-12 ? (y2 = di(C2, $2, P2, q2, c2, -N2, g2), m2 = di(T2, j2, L2, V2, c2, -N2, g2), u2.lineTo(y2.cx + y2.x01, y2.cy + y2.y01), N2 < O2 ? u2.arc(y2.cx, y2.cy, N2, Zr(y2.y01, y2.x01), Zr(m2.y01, m2.x01), !g2) : (u2.arc(y2.cx, y2.cy, N2, Zr(y2.y01, y2.x01), Zr(y2.y11, y2.x11), !g2), u2.arc(0, 0, c2, Zr(y2.cy + y2.y11, y2.cx + y2.x11), Zr(m2.cy + m2.y11, m2.cx + m2.x11), g2), u2.arc(m2.cx, m2.cy, N2, Zr(m2.y11, m2.x11), Zr(m2.y01, m2.x01), !g2))) : u2.arc(0, 0, c2, w2, b2, g2) : u2.lineTo(C2, $2);
        }
      else
        u2.moveTo(0, 0);
      if (u2.closePath(), s3)
        return u2 = null, s3 + "" || null;
    }
    return s2.centroid = function() {
      var n4 = (+t13.apply(this, arguments) + +e3.apply(this, arguments)) / 2, r4 = (+i2.apply(this, arguments) + +o2.apply(this, arguments)) / 2 - ri / 2;
      return [Kr(r4) * n4, ei(r4) * n4];
    }, s2.innerRadius = function(e4) {
      return arguments.length ? (t13 = typeof e4 == "function" ? e4 : Yr(+e4), s2) : t13;
    }, s2.outerRadius = function(t14) {
      return arguments.length ? (e3 = typeof t14 == "function" ? t14 : Yr(+t14), s2) : e3;
    }, s2.cornerRadius = function(t14) {
      return arguments.length ? (n3 = typeof t14 == "function" ? t14 : Yr(+t14), s2) : n3;
    }, s2.padRadius = function(t14) {
      return arguments.length ? (r3 = t14 == null ? null : typeof t14 == "function" ? t14 : Yr(+t14), s2) : r3;
    }, s2.startAngle = function(t14) {
      return arguments.length ? (i2 = typeof t14 == "function" ? t14 : Yr(+t14), s2) : i2;
    }, s2.endAngle = function(t14) {
      return arguments.length ? (o2 = typeof t14 == "function" ? t14 : Yr(+t14), s2) : o2;
    }, s2.padAngle = function(t14) {
      return arguments.length ? (a2 = typeof t14 == "function" ? t14 : Yr(+t14), s2) : a2;
    }, s2.context = function(t14) {
      return arguments.length ? (u2 = t14 != null ? t14 : null, s2) : u2;
    }, s2;
  }().innerRadius(r2 - t12.ringWidth - t12.ringInset).outerRadius(r2 - t12.ringInset).startAngle((r3, i2) => {
    const o2 = Rr(e2, i2);
    return Vr(t12.minAngle + o2 * n2);
  }).endAngle((r3, i2) => {
    const o2 = Rr(e2, i2 + 1);
    return Vr(t12.minAngle + o2 * n2);
  });
});
const Sa = ({ d3_refs: t12, newValue: e2, config: n2 }) => {
  const r2 = ba(n2)(e2), i2 = n2.maxAngle - n2.minAngle, o2 = n2.minAngle + r2 * i2;
  t12.pointer.transition(function({ duration: t13, ease: e3 }) {
    return To().duration(t13).ease(e3);
  }({ duration: n2.needleTransitionDuration, ease: ya(n2.needleTransition) })).attr("transform", `rotate(${o2})`), t12.current_value_text.text(function(t13, e3) {
    const n3 = e3.labelFormat(t13), r3 = e3.currentValuePlaceholderStyle;
    return e3.currentValueText.replace(r3, n3);
  }(e2, n2));
}, Aa = ({ container: t12, config: e2 }) => {
  const n2 = function(t13) {
    return t13.width / 2;
  }(e2), r2 = function(t13, e3, n3) {
    return `translate(${t13 + e3}, ${t13 + n3})`;
  }(n2, e2.paddingHorizontal, e2.paddingVertical), i2 = function({ container: t13, config: e3 }) {
    const n3 = e3.width + 2 * e3.paddingHorizontal, r3 = e3.height + 2 * e3.paddingVertical;
    return Rt(t13).append("svg:svg").attr("class", "speedometer").attr("width", `${n3}${e3.dimensionUnit}`).attr("height", `${r3}${e3.dimensionUnit}`).attr("role", "img").attr("focusable", "false").attr("aria-label", e3.svgAriaLabel).style("width", `${n3}${e3.dimensionUnit}`).style("height", `${r3}${e3.dimensionUnit}`);
  }({ container: t12, config: e2 });
  return function({ config: t13, svg: e3, centerTx: n3 }) {
    const r3 = xa(t13), i3 = Ma(t13);
    e3.append("g").attr("class", "arc").attr("transform", n3).selectAll("path").data(r3).enter().append("path").attr("class", "speedo-segment").attr("fill", (e4, n4) => !wr(t13.segmentColors) && t13.segmentColors[n4] ? t13.segmentColors[n4] : t13.arcColorFn(e4 * n4)).attr("d", i3);
  }({ config: e2, svg: i2, centerTx: r2 }), function({ config: t13, svg: e3, centerTx: n3, r: r3 }) {
    const i3 = wa(t13), o2 = xa(t13), a2 = ba(t13), u2 = t13.maxAngle - t13.minAngle, { customSegmentLabels: s2 } = t13, l2 = ar(s2) && !wr(s2), c2 = l2 && s2.length === o2.length;
    if (l2 && !c2)
      throw new Error(`Custom Segment Labels should be an array with length of ${o2.length}`);
    if (l2 && c2)
      return void function({ config: t14, svg: e4, centerTx: n4, r: r4, ticks: i4, tickData: o3, scale: a3, range: u3 }) {
        const { customSegmentStops: s3, customSegmentLabels: l3 } = t14;
        function c3(e5, n5) {
          const r5 = s3.length === 0 ? a3(e5) : Rr(o3, n5);
          return t14.minAngle + r5 * u3;
        }
        const h2 = l3.map((t15, e5) => {
          const n5 = e5, r5 = e5 + 1, o4 = c3(i4[n5], n5);
          return (c3(i4[r5], r5) + o4) / 2;
        }), f2 = r4 - t14.ringWidth - t14.ringInset, p2 = r4 - t14.ringInset, d2 = p2 - (p2 - f2) / 2;
        e4.append("g").attr("class", "label").attr("transform", n4).selectAll("text").data(l3).enter().append("text").attr("transform", (e5, n5) => {
          const i5 = h2[n5], o4 = `rotate(${i5}) translate(0, ${t14.labelInset - r4})`, a4 = `rotate(${i5}) translate(0, ${t14.labelInset / 2 - d2})`;
          return e5.position === "OUTSIDE" ? o4 : a4;
        }).text((t15) => t15.text || "").attr("class", "segment-value").style("text-anchor", "middle").style("font-size", (e5) => e5.fontSize || t14.labelFontSize).style("font-weight", "bold").style("fill", (e5) => e5.color || t14.textColor);
      }({ config: t13, svg: e3, centerTx: n3, r: r3, ticks: i3, tickData: o2, scale: a2, range: u2 });
    e3.append("g").attr("class", "label").attr("transform", n3).selectAll("text").data(i3).enter().append("text").attr("transform", (e4, n4) => {
      const i4 = t13.customSegmentStops.length === 0 ? a2(e4) : Rr(o2, n4);
      return `rotate(${t13.minAngle + i4 * u2}) translate(0, ${t13.labelInset - r3})`;
    }).text(t13.labelFormat).attr("class", "segment-value").style("text-anchor", "middle").style("font-size", t13.labelFontSize).style("font-weight", "bold").style("fill", t13.textColor);
  }({ config: e2, svg: i2, centerTx: r2, r: n2 }), { current_value_text: Oa({ config: e2, svg: i2 }), pointer: Na({ config: e2, svg: i2, r: n2, centerTx: r2 }) };
};
function Oa({ config: t12, svg: e2 }) {
  const n2 = (t12.width + 2 * t12.paddingHorizontal) / 2, r2 = (t12.width + 4 * t12.paddingVertical) / 2;
  return e2.append("g").attr("transform", `translate(${n2}, ${r2})`).append("text").attr("class", "current-value").attr("text-anchor", "middle").attr("y", 23).text(t12.currentValue).style("font-size", t12.valueTextFontSize).style("font-weight", t12.valueTextFontWeight).style("fill", t12.textColor);
}
function Na({ config: t12, svg: e2, r: n2, centerTx: r2 }) {
  const i2 = function({ heightRatio: t13, radius: e3 }) {
    if (t13 < 0 || t13 > 1)
      throw new Error(`Invalid needleHeightRatio given - ${t13}`);
    return Math.round(e3 * t13);
  }({ heightRatio: t12.needleHeightRatio, radius: n2 }), o2 = [[t12.pointerWidth / 2, 0], [0, -i2], [-t12.pointerWidth / 2, 0], [0, t12.pointerTailLength], [t12.pointerWidth / 2, 0]], a2 = _i().curve(Ai);
  return e2.append("g").data([o2]).attr("class", "pointer").attr("transform", r2).style("fill", t12.needleColor).append("path").attr("d", a2).attr("transform", `rotate(${t12.minAngle})`);
}
var ka = { exports: {} }, Ea = {}, Ia = t, Ta = Symbol.for("react.element"), ja = Symbol.for("react.fragment"), Ca = Object.prototype.hasOwnProperty, $a = Ia.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, Ra = { key: true, ref: true, __self: true, __source: true };
function Pa(t12, e2, n2) {
  var r2, i2 = {}, o2 = null, a2 = null;
  for (r2 in n2 !== void 0 && (o2 = "" + n2), e2.key !== void 0 && (o2 = "" + e2.key), e2.ref !== void 0 && (a2 = e2.ref), e2)
    Ca.call(e2, r2) && !Ra.hasOwnProperty(r2) && (i2[r2] = e2[r2]);
  if (t12 && t12.defaultProps)
    for (r2 in e2 = t12.defaultProps)
      i2[r2] === void 0 && (i2[r2] = e2[r2]);
  return { $$typeof: Ta, type: t12, key: o2, ref: a2, props: i2, _owner: $a.current };
}
Ea.Fragment = ja, Ea.jsx = Pa, Ea.jsxs = Pa, ka.exports = Ea;
const qa = ka.exports.jsx;
class La extends e {
  constructor(t12) {
    super(t12);
    __publicField(this, "render", () => qa("div", { ref: (t12) => this.gaugeDiv = t12 }));
    this.d3_refs = { pointer: false, current_value_text: false };
  }
  componentDidMount() {
    this.renderGauge();
  }
  componentDidUpdate() {
    this.props.forceRender ? this.renderGauge() : this.updateReadings();
  }
  renderGauge() {
    this.config = (({ PROPS: t12, parentWidth: e2, parentHeight: n2 }) => {
      const r2 = { width: t12.fluidWidth ? e2 : t12.width, height: t12.fluidWidth ? n2 : t12.height, paddingHorizontal: t12.paddingHorizontal, paddingVertical: t12.paddingVertical, dimensionUnit: t12.dimensionUnit, ringWidth: t12.ringWidth, minValue: t12.minValue, maxValue: t12.maxValue, needleColor: t12.needleColor, majorTicks: t12.segments, customSegmentStops: t12.customSegmentStops, customSegmentLabels: t12.customSegmentLabels, maxSegmentLabels: qr({ maxSegmentLabelCount: t12.maxSegmentLabels, segmentCount: t12.segments }), segmentColors: t12.segmentColors, arcColorFn: t12.segmentColors.length > 0 ? sn(t12.segmentColors) : Qe(fe(t12.startColor), fe(t12.endColor)), needleTransition: t12.needleTransition, needleTransitionDuration: t12.needleTransitionDuration, needleHeightRatio: t12.needleHeightRatio, textColor: t12.textColor, labelFormat: y(t12.valueFormat), currentValueText: t12.currentValueText, currentValuePlaceholderStyle: t12.currentValuePlaceholderStyle, labelFontSize: t12.labelFontSize, valueTextFontSize: t12.valueTextFontSize, valueTextFontWeight: t12.valueTextFontWeight, svgAriaLabel: t12.svgAriaLabel };
      return Object.assign({}, Br, r2);
    })({ PROPS: this.props, parentWidth: this.gaugeDiv.parentNode.clientWidth, parentHeight: this.gaugeDiv.parentNode.clientHeight }), Rt(this.gaugeDiv).select("svg").remove(), this.d3_refs = Aa({ container: this.gaugeDiv, config: this.config }), Sa({ d3_refs: this.d3_refs, newValue: this.props.value, config: this.config });
  }
  updateReadings() {
    var t12, e2;
    this.config = (t12 = this.config, e2 = { labelFormat: y(this.props.valueFormat || ""), currentValueText: this.props.currentValueText || "${value}" }, __spreadValues(__spreadValues({}, t12), e2)), Sa({ d3_refs: this.d3_refs, newValue: this.props.value || 0, config: this.config });
  }
}
__publicField(La, "displayName", "ReactSpeedometer");
La.propTypes = { value: o.number.isRequired, minValue: o.number.isRequired, maxValue: o.number.isRequired, forceRender: o.bool.isRequired, width: o.number.isRequired, height: o.number.isRequired, paddingHorizontal: o.number.isRequired, paddingVertical: o.number.isRequired, dimensionUnit: o.string.isRequired, fluidWidth: o.bool.isRequired, segments: o.number.isRequired, maxSegmentLabels: o.number, customSegmentStops: o.array, customSegmentLabels: o.arrayOf(o.shape({ text: o.string, position: o.oneOf(["OUTSIDE", "INSIDE"]), fontSize: o.string, color: o.string })), needleColor: o.string.isRequired, startColor: o.string.isRequired, endColor: o.string.isRequired, segmentColors: o.array.isRequired, needleTransition: o.string.isRequired, needleTransitionDuration: o.number.isRequired, needleHeightRatio: o.number.isRequired, ringWidth: o.number.isRequired, textColor: o.string.isRequired, valueFormat: o.string.isRequired, currentValueText: o.string.isRequired, currentValuePlaceholderStyle: o.string.isRequired, labelFontSize: o.string.isRequired, valueTextFontSize: o.string.isRequired, valueTextFontWeight: o.string.isRequired }, La.defaultProps = zr;
export { Fr as CustomSegmentLabelPosition, Dr as Transition, La as default };
